import { useParams } from 'react-router-dom';
import React, { useState, useEffect, useRef } from 'react';
import moment from 'moment';
import axios from 'axios';
import { Form, Row, Col, Table, FormControl, Container, InputGroup, Button, Modal } from 'react-bootstrap';
import { MDBIcon } from 'mdb-react-ui-kit';
import { toast } from 'react-toastify';
import approvedStamp from '../../images/approvedStamp.png';
import '../../css/preloadingform.css';
import '../../index.css';
import apiService from '../../services/api.services';
import Navbar from '../../components/common/Navbar';


const PreloadingForm = () => {
  const { series } = useParams();

  const [userName, setuserName] = useState('');
  const [userId, setuserId] = useState('');
  const [userRole, setuserRole] = useState('');
  const [status, setStatus] = useState('');
  const [formReopenCount, setformReopenCount] = useState(0);
  const [sendForAppv, setSendForAppv] = useState()
  const [file1, setFile1] = useState(null);
  const [fileName1, setFileName1] = useState('No File Selected');
  const [file1url, setFile1url] = useState('')
  const [file2, setFile2] = useState(null);
  const [fileName2, setFileName2] = useState('No File Selected');
  const [file2url, setFile2url] = useState('')
  const [file3, setFile3] = useState(null);
  const [fileName3, setFileName3] = useState('No File Selected');
  const [file3url, setFile3url] = useState('')
  const [file4, setFile4] = useState(null);
  const [fileName4, setFileName4] = useState('No File Selected');
  const [file4url, setFile4url] = useState('')
  const [file5, setFile5] = useState(null);
  const [fileName5, setFileName5] = useState('No File Selected');
  const [file5url, setFile5url] = useState('')
  const [crmData, setcrmData] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [showDropdown, setShowDropdown] = useState(false);
  const [customerName, setcustomerName] = useState('');
  const [salesPersonName, setsalesPersonName] = useState('');
  const [salesPersonID, setsalesPersonID] = useState('');
  const [panNumber, setpanNumber] = useState('');
  const [preloadingReason, setpreloadingReason] = useState('');
  const [lowMarginReason, setLowMarginReason] = useState('');
  const [oem, setOem] = useState("");
  // const [approvalRequestDate, setapprovalRequestDate] = useState(moment().format('dddd, DD MMMM, YYYY'));
  const [approvalRequestDate, setApprovalRequestDate] = useState(moment().format("YYYY-MM-DD"));
  const [sendForAppvReqDate, setSendForAppvReqDate] = useState('');
  const [opportunityName, setopportunityName] = useState('');
  const [customerSatisfaction, setcustomerSatisfaction] = useState('');
  const [expectedPOTimeDays, setexpectedPOTimeDays] = useState(0);
  const [customerCreditPeriodDays, setcustomerCreditPeriodDays] = useState(0);
  const [vendorDeliveryDays, setvendorDeliveryDays] = useState(0);
  const [vendorCreditPeriodDays, setvendorCreditPeriodDays] = useState(0);
  const [vendorBillingCycle, setvendorBillingCycle] = useState('');
  const [expectedPODate, setexpectedPODate] = useState(null);
  const [cashFlowExpertAdvice, setcashFlowExpertAdvice] = useState('');
  const [marginExpertAdvice, setmarginExpertAdvice] = useState('');
  const [sellingValueYear1, setsellingValueYear1] = useState(0);
  const [sellingValueYear2, setsellingValueYear2] = useState(0);
  const [sellingValueYear3, setsellingValueYear3] = useState(0);
  const [sellingValueYear4, setsellingValueYear4] = useState(0);
  const [sellingValueYear5, setsellingValueYear5] = useState(0);
  const [sellingValueYear6, setsellingValueYear6] = useState(0);
  const [sellingValueYear7, setsellingValueYear7] = useState(0);
  const [sellingValueTotal, setsellingValueTotal] = useState(0);
  const [purchaseValueYear1, setpurchaseValueYear1] = useState(0);
  const [purchaseValueYear2, setpurchaseValueYear2] = useState(0);
  const [purchaseValueYear3, setpurchaseValueYear3] = useState(0);
  const [purchaseValueYear4, setpurchaseValueYear4] = useState(0);
  const [purchaseValueYear5, setpurchaseValueYear5] = useState(0);
  const [purchaseValueYear6, setpurchaseValueYear6] = useState(0);
  const [purchaseValueYear7, setpurchaseValueYear7] = useState(0);
  const [purchaseValueTotal, setpurchaseValueTotal] = useState(0);
  const [marginYear1, setmarginYear1] = useState(0);
  const [marginYear2, setmarginYear2] = useState(0);
  const [marginYear3, setmarginYear3] = useState(0);
  const [marginYear4, setmarginYear4] = useState(0);
  const [marginYear5, setmarginYear5] = useState(0);
  const [marginYear6, setmarginYear6] = useState(0);
  const [marginYear7, setmarginYear7] = useState(0);
  const [marginYearTotal, setmarginYearTotal] = useState(0);
  const [marginPercentage, setmarginPercentage] = useState(0.00);
  const [appvTeamLeaderId, setAppvTeamLeaderId] = useState('');
  const [appvBranchHeadId, setAppvBranchHeadId] = useState('');
  const [appvRegionBusinessHeadId, setAppvRegionBusinessHeadId] = useState('');
  const [appvBusinessFinanceId, setAppvBusinessFinanceId] = useState('');
  const [appvExportComplianceId, setAppvExportComplianceId] = useState('');
  const [appvCreditInsuranceId, setAppvCreditInsuranceId] = useState('');
  const [appvCEOId, setAppvCEOId] = useState('');
  const [appvCOOId, setAppvCOOId] = useState('');
  const [appvCFOId, setAppvCFOId] = useState('');
  const [appvSVPDirectorId, setAppvSVPDirectorId] = useState('');
  const [appvTeamLeaderReq, setAppvTeamLeaderReq] = useState('');
  const [appvBranchHeadReq, setAppvBranchHeadReq] = useState('');
  const [appvRegionBusinessHeadReq, setAppvRegionBusinessHeadReq] = useState('');
  const [appvBusinessFinanceReq, setAppvBusinessFinanceReq] = useState('');
  const [appvExportComplianceReq, setAppvExportComplianceReq] = useState('');
  const [appvCreditInsuranceReq, setAppvCreditInsuranceReq] = useState('');
  const [appvCEOReq, setAppvCEOReq] = useState('');
  const [appvCOOReq, setAppvCOOReq] = useState('');
  const [appvCFOReq, setAppvCFOReq] = useState('');
  const [appvSVPDirectorReq, setAppvSVPDirectorReq] = useState('');
  const [appvTeamLeaderStatus, setAppvTeamLeaderStatus] = useState('');
  const [appvBranchHeadStatus, setAppvBranchHeadStatus] = useState('');
  const [appvRegionBusinessHeadStatus, setAppvRegionBusinessHeadStatus] = useState('');
  const [appvBusinessFinanceStatus, setAppvBusinessFinanceStatus] = useState('');
  const [appvExportComplianceStatus, setAppvExportComplianceStatus] = useState('');
  const [appvCreditInsuranceStatus, setAppvCreditInsuranceStatus] = useState('');
  const [appvCEOStatus, setAppvCEOStatus] = useState('');
  const [appvCOOStatus, setAppvCOOStatus] = useState('');
  const [appvCFOStatus, setAppvCFOStatus] = useState('');
  const [appvSVPDirectorStatus, setAppvSVPDirectorStatus] = useState('');
  const [response, setResponse] = useState('');
  const [approvalMessage, setApprovalMessage] = useState('');
  const [rejectionMessage, setRejectionMessage] = useState("");
  const [showThankYou, setShowThankYou] = useState(false);
  const [modalSentForAppv, setModalSentForAppv] = useState(false);
  const [showReopen, setShowReopen] = useState(false);
  const [step, setStep] = useState(1);
  const [ques1, setQues1] = useState('');
  const [ques2, setQues2] = useState('');
  const [ques3, setQues3] = useState('');
  const [ques4, setQues4] = useState('');
  const [ques5, setQues5] = useState('');
  const [ques6, setQues6] = useState('');
  const [ques7, setQues7] = useState('');
  const [ques8, setQues8] = useState('');
  const [ques9, setQues9] = useState('');
  const [ques10, setQues10] = useState('');
  const [ques11, setQues11] = useState('');
  const [ques12, setQues12] = useState('');
  const [ques13, setQues13] = useState('');
  const [ques14, setQues14] = useState('');
  const [showExCompRemark, setExCompRemark] = useState(false);
  const [ExCompMessage, setExCompMessage] = useState('');
  const [fileSaveTrigger, setfileSaveTrigger] = useState(0);
  


  const [loading, setLoading] = useState(true);
  const [isReadOnly, setIsReadOnly] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const addedsellingValueTotal = parseInt(sellingValueYear1) + parseInt(sellingValueYear2) + parseInt(sellingValueYear3) +
      parseInt(sellingValueYear4) + parseInt(sellingValueYear5) + parseInt(sellingValueYear6) + parseInt(sellingValueYear7);
    setsellingValueTotal(isNaN(addedsellingValueTotal) ? 0 : addedsellingValueTotal);

    const addPurchaseValueTotal = parseInt(purchaseValueYear1) + parseInt(purchaseValueYear2) + parseInt(purchaseValueYear3) +
      parseInt(purchaseValueYear4) + parseInt(purchaseValueYear5) + parseInt(purchaseValueYear6) + parseInt(purchaseValueYear7);
    setpurchaseValueTotal(isNaN(addPurchaseValueTotal) ? 0 : addPurchaseValueTotal);

    const addMarginYearTotal = marginYear1 + marginYear2 + marginYear3 + marginYear4 + marginYear5 + marginYear6 + marginYear7;
    setmarginYearTotal(isNaN(addMarginYearTotal) ? 0 : addMarginYearTotal);

    let calMarginYear1 = parseInt(sellingValueYear1) - parseInt(purchaseValueYear1);
    setmarginYear1(isNaN(calMarginYear1) ? 0 : calMarginYear1);
    let calMarginYear2 = parseInt(sellingValueYear2) - parseInt(purchaseValueYear2);
    setmarginYear2(isNaN(calMarginYear2) ? 0 : calMarginYear2);
    let calMarginYear3 = parseInt(sellingValueYear3) - parseInt(purchaseValueYear3);
    setmarginYear3(isNaN(calMarginYear3) ? 0 : calMarginYear3);
    let calMarginYear4 = parseInt(sellingValueYear4) - parseInt(purchaseValueYear4);
    setmarginYear4(isNaN(calMarginYear4) ? 0 : calMarginYear4);
    let calMarginYear5 = parseInt(sellingValueYear5) - parseInt(purchaseValueYear5);
    setmarginYear5(isNaN(calMarginYear5) ? 0 : calMarginYear5);
    let calMarginYear6 = parseInt(sellingValueYear6) - parseInt(purchaseValueYear6);
    setmarginYear6(isNaN(calMarginYear6) ? 0 : calMarginYear6);
    let calMarginYear7 = parseInt(sellingValueYear7) - parseInt(purchaseValueYear7);
    setmarginYear7(isNaN(calMarginYear7) ? 0 : calMarginYear7);

    if (sellingValueTotal !== 0) {
      const totalMarginPercentage = ((marginYearTotal / sellingValueTotal) * 100).toFixed(2);
      setmarginPercentage(isNaN(totalMarginPercentage) ? 0.00 : totalMarginPercentage);
    }


    // const sumdate = parseInt(vendorCreditPeriodDays) + parseInt(vendorDeliveryDays);
    // const addDays = moment(approvalRequestDate, 'dddd, D MMMM, YYYY').add(sumdate, 'days').format('dddd, D MMMM, YYYY');
    // const subDays = moment(addDays, 'dddd, D MMMM, YYYY').diff(moment(expectedPODate, 'dddd, D MMMM, YYYY'), 'days');
    // const result = subDays - parseInt(customerCreditPeriodDays);

    // const sumdate = parseInt(vendorCreditPeriodDays) + parseInt(vendorDeliveryDays);
    // console.log(`${sumdate}, ${parseInt(vendorCreditPeriodDays)}, ${parseInt(vendorDeliveryDays)}`)
    // const addDays = moment(approvalRequestDate, 'dddd, D MMMM, YYYY').add(sumdate, 'days').format('dddd, D MMMM, YYYY');
    // console.log(`${addDays}, ${moment(approvalRequestDate, 'dddd, D MMMM, YYYY')}, ${(sumdate, 'days').format('dddd, D MMMM, YYYY')}`)
    // const subDays = moment(addDays, 'dddd, D MMMM, YYYY').diff(moment(expectedPODate, 'dddd, D MMMM, YYYY'), 'days');
    // console.log(`${subDays}, ${moment(addDays, 'dddd, D MMMM, YYYY')}, ${(moment(expectedPODate, 'dddd, D MMMM, YYYY'), 'days')}`)
    // const result = subDays - parseInt(customerCreditPeriodDays);
    // console.log(`sumdate:: ${sumdate},
    //   addDays:: ${addDays},
    //   subDays:: ${subDays},
    //   result:: ${result}`)

//   // Step 1: sumdate
// const sumdate = parseInt(vendorCreditPeriodDays) + parseInt(vendorDeliveryDays);

// // Step 2: add sumdate days to approvalRequestDate
// const addDaysMoment = moment(approvalRequestDate, 'dddd, D MMMM, YYYY').add(sumdate, 'days');

// // Step 3: calculate difference in days from expectedPODate
// const subDays = addDaysMoment.diff(moment(expectedPODate, 'dddd, D MMMM, YYYY'), 'days');

// // Step 4: subtract customer credit period
// const result = subDays - parseInt(customerCreditPeriodDays);

// // Step 5: log results
// console.log(`sumdate:: ${sumdate},
//       addDays:: ${addDaysMoment},
//       subDays:: ${subDays},
//       result:: ${result}`)

const sumdate = parseInt(vendorCreditPeriodDays) + parseInt(vendorDeliveryDays);

// const addDaysMoment = moment(approvalRequestDate, 'D MMMM, YYYY').add(sumdate, 'days');

const addDaysMoment2 = moment(sendForAppvReqDate, 'YYYY-MM-DD').add(sumdate, 'days');

// const subDays = addDaysMoment.diff(moment(expectedPODate, 'D MMMM, YYYY'), 'days');

const subDays2 = addDaysMoment2.diff(moment(expectedPODate, 'YYYY-MM-DD'), 'days');

// const result = subDays - parseInt(customerCreditPeriodDays);

const result = subDays2 - parseInt(customerCreditPeriodDays);

console.log(`sumdate:: ${sumdate},
      approvalRequestDate:: ${approvalRequestDate},
      sendForAppvReqDate:: ${sendForAppvReqDate},
      addDays2:: ${addDaysMoment2.format('dddd, D MMMM, YYYY')},
      expectedPODate::${expectedPODate},
      subDays2:: ${subDays2},
      result2:: ${result},
    `)

    if (result <= 0) {
      setcashFlowExpertAdvice("It's become FC Impacted deal, hence wait for customer PO");
    } else {
      setcashFlowExpertAdvice("It's favourable to Hitachi");
    }
    if (sellingValueTotal == 0 || purchaseValueTotal == 0 || marginYearTotal == 0) {
      setmarginExpertAdvice("");
    }
    else {
      if (oem === "Microsoft") {
        if (marginPercentage >= 2.00) {
          setmarginExpertAdvice("Ok from margin prospective");
        } else {
          setmarginExpertAdvice("Since margin very low hence work on margin first, then move to pre-loading of the order");
        }
      } else if (oem === "Other than Microsoft") {
        if (marginPercentage >= 6.00) {
          setmarginExpertAdvice("Ok from margin prospective");
        } else {
          setmarginExpertAdvice("Since margin very low hence work on margin first, then move to pre-loading of the order");
        }
      } else {
        setmarginExpertAdvice("");
      }
    }


  }, [sellingValueTotal, sellingValueYear1, sellingValueYear2, sellingValueYear3, sellingValueYear4,
    sellingValueYear5, sellingValueYear6, sellingValueYear7, purchaseValueTotal, purchaseValueYear1,
    purchaseValueYear2, purchaseValueYear3, purchaseValueYear4, purchaseValueYear5, purchaseValueYear6,
    purchaseValueYear7, marginYearTotal, marginYear1, marginYear2, marginYear3, marginYear4, marginYear5,
    marginYear6, marginYear7, approvalRequestDate, vendorCreditPeriodDays, vendorDeliveryDays, expectedPODate,
    customerCreditPeriodDays, oem, marginExpertAdvice, marginPercentage]);

  useEffect(() => {
    const JWTtoken = window.sessionStorage.getItem('token')
    const loginID = window.sessionStorage.getItem('userId')
    const loginRole = window.sessionStorage.getItem('role')
    apiService.getcrmDetails(JWTtoken, loginID, loginRole)
      .then(response => {
        setcrmData(response.data);
        setLoading(false);
      })
      .catch(error => {
        setError(error);
        setLoading(false);
      });
    apiService.getDataAgainstPreloading(JWTtoken, series)
      .then(response => {
        console.log(':::::Saved Record Against current Document ID::::::::', response.data.sentForAppv);
        setSendForAppv(response.data.sentForAppv)
        setSearchTerm(response.data.crmNumber)
        setcustomerName(response.data.customerName)
        setsalesPersonName(response.data.salesPersonName)
        setsalesPersonID(response.data.salesPersonID)
        setpanNumber(response.data.pan);
        setpreloadingReason(response.data.reasonToLoadOrderAsPreloading)
        setLowMarginReason(response.data.lowMarginReason)
        setOem(response.data.OEM)
        setStatus(response.data.status)
        setformReopenCount(response.data.formReopenCount)
        setFile1url(response.data.file1url)
        setFile2url(response.data.file2url)
        setFile3url(response.data.file3url)
        setFile4url(response.data.file4url)
        setFile5url(response.data.file5url)
        setFileName1(response.data.fileName1)
        setFileName2(response.data.fileName2)
        setFileName3(response.data.fileName3)
        setFileName4(response.data.fileName4)
        setFileName5(response.data.fileName5)
        setSendForAppvReqDate(response.data.approvalRequestDate)
        // setapprovalRequestDate(response.data.approvalRequestDate)
        setopportunityName(response.data.opportunityName)
        setcustomerSatisfaction(response.data.customerConfirmation)
        setexpectedPOTimeDays(response.data.expectedTimeInDaysToGetFinalPOFromCustomer)
        setcustomerCreditPeriodDays(response.data.customerCreditPeriodForThisDealInDays)
        setvendorDeliveryDays(response.data.expectedDaysOfDeliveryOfProductFromVendor)
        setvendorCreditPeriodDays(response.data.vendorCreditPeriodForThisDealInDays)
        setvendorBillingCycle(response.data.vendorBillingCycle)
        setexpectedPODate(response.data.expectedPoDate ? moment(response.data.expectedPoDate).format("YYYY-MM-DD") : null)
        // setexpectedPODate(moment().add((response.data.expectedTimeInDaysToGetFinalPOFromCustomer), 'days').format('dddd, DD MMMM, YYYY'))
        setcashFlowExpertAdvice(response.data.expertAdviceCashflow)
        setmarginExpertAdvice(response.data.expertAdviceMargin)
        setsellingValueYear1(response.data.sellingValueYear1)
        setsellingValueYear2(response.data.sellingValueYear2)
        setsellingValueYear3(response.data.sellingValueYear3)
        setsellingValueYear4(response.data.sellingValueYear4)
        setsellingValueYear5(response.data.sellingValueYear5)
        setsellingValueYear6(response.data.sellingValueYear6)
        setsellingValueYear7(response.data.sellingValueYear7)
        setsellingValueTotal(response.data.sellingValueTotal)
        setpurchaseValueYear1(response.data.purchaseValueYear1)
        setpurchaseValueYear2(response.data.purchaseValueYear2)
        setpurchaseValueYear3(response.data.purchaseValueYear3)
        setpurchaseValueYear4(response.data.purchaseValueYear4)
        setpurchaseValueYear5(response.data.purchaseValueYear5)
        setpurchaseValueYear6(response.data.purchaseValueYear6)
        setpurchaseValueYear7(response.data.purchaseValueYear7)
        setpurchaseValueTotal(response.data.purchaseValueTotal)
        setmarginYear1(response.data.marginYear1)
        setmarginYear2(response.data.marginYear2)
        setmarginYear3(response.data.marginYear3)
        setmarginYear4(response.data.marginYear4)
        setmarginYear5(response.data.marginYear5)
        setmarginYear6(response.data.marginYear6)
        setmarginYear7(response.data.marginYear7)
        setmarginYearTotal(response.data.marginYearTotal)
        setmarginPercentage(response.data.marginPercentage)
        setQues1(response.data.ExCompQues1);
        setQues2(response.data.ExCompQues2);
        setQues3(response.data.ExCompQues3);
        setQues4(response.data.ExCompQues4);
        setQues5(response.data.ExCompQues5);
        setQues6(response.data.ExCompQues6);
        setQues7(response.data.ExCompQues7);
        setQues8(response.data.ExCompQues8);
        setQues9(response.data.ExCompQues9);
        setQues10(response.data.ExCompQues10);
        setQues11(response.data.ExCompQues11);
        setQues12(response.data.ExCompQues12);
        setQues13(response.data.ExCompQues13);
        setQues14(response.data.ExCompQues14);
      })
    apiService.getappvdata(JWTtoken, series)
      .then(response => {
        setAppvTeamLeaderId(response.data.appvTeamLeaderID)
        setAppvBranchHeadId(response.data.appvBranchHeadID)
        setAppvRegionBusinessHeadId(response.data.appvRegionBusinessHeadID)
        setAppvBusinessFinanceId(response.data.appvBusinessFinanceID)
        setAppvExportComplianceId(response.data.appvExportComplianceID)
        setAppvCreditInsuranceId(response.data.appvCreditInsuranceID)
        setAppvCEOId(response.data.appvCEOID)
        setAppvCOOId(response.data.appvCOOID)
        setAppvCFOId(response.data.appvCFOID)
        setAppvSVPDirectorId(response.data.appvSVPDirectorID)
        setAppvTeamLeaderReq(response.data.appvTeamLeaderReq)
        setAppvBranchHeadReq(response.data.appvBranchHeadReq)
        setAppvRegionBusinessHeadReq(response.data.appvRegionBusinessHeadReq)
        setAppvBusinessFinanceReq(response.data.appvBusinessFinanceReq)
        setAppvExportComplianceReq(response.data.appvExportComplianceReq)
        setAppvCreditInsuranceReq(response.data.appvCreditInsuranceReq)
        setAppvCEOReq(response.data.appvCEOReq)
        setAppvCOOReq(response.data.appvCOOReq)
        setAppvCFOReq(response.data.appvCFOReq)
        setAppvSVPDirectorReq(response.data.appvSVPDirectorReq)
        setAppvTeamLeaderStatus(response.data.appvTeamLeaderStatus)
        setAppvBranchHeadStatus(response.data.appvBranchHeadStatus)
        setAppvRegionBusinessHeadStatus(response.data.appvRegionBusinessHeadStatus)
        setAppvBusinessFinanceStatus(response.data.appvBusinessFinanceStatus)
        setAppvExportComplianceStatus(response.data.appvExportComplianceStatus)
        setAppvCreditInsuranceStatus(response.data.appvCreditInsuranceStatus)
        setAppvCEOStatus(response.data.appvCEOStatus)
        setAppvCOOStatus(response.data.appvCOOStatus)
        setAppvCFOStatus(response.data.appvCFOStatus)
        setAppvSVPDirectorStatus(response.data.appvSVPDirectorStatus)
      })

    let user_name = window.sessionStorage.getItem('userName');
    if (user_name) {
      console.log(':::::current user is::::::::', user_name);
      setuserName(user_name);
    }
    let user_id = window.sessionStorage.getItem('userId');
    if (user_id) {
      setuserId(user_id);
    }
    let user_role = window.sessionStorage.getItem('role');
    if (user_role) {
      setuserRole(user_role);
    }
  }, [series, sendForAppv]);

  useEffect(() => {
    if(fileSaveTrigger === 0) return;
    const timer = setTimeout(() => {
      handleAutoSave();
    }, 1000);
    return () => clearTimeout(timer);
  }, [file1,fileName1,file2,fileName2,file3,fileName3,file4,fileName4,file5,fileName5]);


  useEffect(() => {
    let approvalRole = window.sessionStorage.getItem('role');
    apiService.confirmedAppv(series)
      .then(response => {
        if (
          (approvalRole === 'TEAM LEADER' && (response.data.appvStatus.appvTeamLeaderStatus === 'Approved' || response.data.appvStatus.appvTeamLeaderStatus === 'Rejected')) ||
          (approvalRole === 'BRANCH HEAD' && (response.data.appvStatus.appvBranchHeadStatus === 'Approved' || response.data.appvStatus.appvBranchHeadStatus === 'Rejected')) ||
          (approvalRole === 'REGION BUSINESS HEAD' && (response.data.appvStatus.appvRegionBusinessHeadStatus === 'Approved' || response.data.appvStatus.appvRegionBusinessHeadStatus === 'Rejected')) ||
          (approvalRole === 'BUSINESS FINANCE' && (response.data.appvStatus.appvBusinessFinanceStatus === 'Approved' || response.data.appvStatus.appvBusinessFinanceStatus === 'Rejected')) ||
          (approvalRole === 'EXPORT COMPLIANCE' && (response.data.appvStatus.appvExportComplianceStatus === 'Approved' || response.data.appvStatus.appvExportComplianceStatus === 'Rejected')) ||
          (approvalRole === 'CREDIT INSURANCE' && (response.data.appvStatus.appvCreditInsuranceStatus === 'Approved' || response.data.appvStatus.appvCreditInsuranceStatus === 'Rejected')) ||
          (approvalRole === 'CEO' && (response.data.appvStatus.appvCEOStatus === 'Approved' || response.data.appvStatus.appvCEOStatus === 'Rejected')) ||
          (approvalRole === 'COO' && (response.data.appvStatus.appvCOOStatus === 'Approved' || response.data.appvStatus.appvCOOStatus === 'Rejected')) ||
          (approvalRole === 'CFO' && (response.data.appvStatus.appvCFOStatus === 'Approved' || response.data.appvStatus.appvCFOStatus === 'Rejected')) ||
          (approvalRole === 'SVP-DIRECTOR' && (response.data.appvStatus.appvSVPDirectorStatus === 'Approved' || response.data.appvStatus.appvSVPDirectorStatus === 'Rejected'))
        ) {
            setShowThankYou(true);
            setResponse(`Your approval is already recorded for this Deal!`)
        }
      })
      .catch(error => {
        setError(error);
      });

  }, []);

  const filteredCrmData = crmData.filter(item =>
    item.crmNumber.toLowerCase().includes(searchTerm.toLowerCase())
  );

  useEffect(() => {
    if (searchTerm === '') {
      setcustomerName('');
      setsalesPersonName('');
      setopportunityName('');
      setsalesPersonID('');
      setpanNumber('');
    }
  }, [searchTerm]);

  const handleSelectChange = (crmNumber) => {
    const crm_num = crmNumber;
    setSearchTerm(crm_num);
    setShowDropdown(false);
    const selectedCrm = crmData.find(item => item.crmNumber === crm_num);

    if (selectedCrm) {
      setcustomerName(selectedCrm.customerName);
      setsalesPersonName(selectedCrm.salesPersonName);
      setopportunityName(selectedCrm.opportunityName);
      setsalesPersonID(selectedCrm.salesPersonID);
      setpanNumber(selectedCrm.pan);
      setQues11(selectedCrm.dealBaseCheckApproval);
    }
    else {
      setcustomerName('');
      setsalesPersonName('');
      setopportunityName('');
      setsalesPersonID('');
      setpanNumber('');
    }
  };

  // ------------------------------------------------------------------------

  const handleSelectFile1 = async (e) => {
    e.preventDefault()
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      setFile1(selectedFile);
      setFileName1(selectedFile.name);
      setfileSaveTrigger((prev)=>prev + 1)
      toast.success(`File Selected: ${selectedFile.name}`);
    }
  };

  const handleRemoveFile1 = () => {
    setFile1(null);
    setFileName1('No File Selected');
    setfileSaveTrigger(0);
    toast.error('File Removed');
  };

  const handleViewFile1 = async () => {
    const JWTtoken = window.sessionStorage.getItem('token')
    
    fileName1 ? apiService.exportPreloadingView(JWTtoken, series, fileName1)
    .then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName1);
      document.body.appendChild(link);
      link.click();
      link.remove();
    })
    .catch(console.error) : toast.error('No File Selected');
    // ----------------------------------------------------------------------------------------------------
    // window.open(file1url, '_blank');
    // file1url ? window.open(file1url, '_blank') : toast.error('No File Selected');
    
    // if (file1url) {
    //   const link = document.createElement('a');
    //   link.href = file1url;
    //   link.download = ''; // let the server suggest the filename
    //   document.body.appendChild(link);
    //   link.click();
    //   document.body.removeChild(link);
    // } else {
    //   toast.error('No File Selected');
    // }
    

  };
  // ------------------------------------------------------------------------
  const handleSelectFile2 = async (e) => {
    e.preventDefault()
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      setFile2(selectedFile);
      setFileName2(selectedFile.name);
      setfileSaveTrigger((prev)=>prev + 1)
      toast.success(`File Selected: ${selectedFile.name}`);
    }
  };

  const handleRemoveFile2 = () => {
    setFile2(null);
    setFileName2('No File Selected');
    setfileSaveTrigger(0);
    toast.error('File Removed');
  };

  const handleViewFile2 = async () => {

    // window.open(file2url, '_blank');
    // file2url ? window.open(file2url, '_blank') : toast.error('No File Selected');

    const JWTtoken = window.sessionStorage.getItem('token')

    fileName2 ? apiService.exportPreloadingView(JWTtoken, series, fileName2)
    .then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName2);
      document.body.appendChild(link);
      link.click();
      link.remove();
    })
    .catch(console.error) : toast.error('No File Selected');

  };
  // ------------------------------------------------------------------------
  const handleSelectFile3 = async (e) => {
    e.preventDefault()
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      setFile3(selectedFile);
      setFileName3(selectedFile.name);
      setfileSaveTrigger((prev)=>prev + 1) 
      toast.success(`File Selected: ${selectedFile.name}`);
    }
  };

  const handleRemoveFile3 = () => {
    setFile3(null);
    setFileName3('No File Selected');
    setfileSaveTrigger(0);
    toast.error('File Removed');
  };

  const handleViewFile3 = async () => {

    // window.open(file3url, '_blank');
    // file3url ? window.open(file3url, '_blank') : toast.error('No File Selected');

    const JWTtoken = window.sessionStorage.getItem('token')

    fileName3 ? apiService.exportPreloadingView(JWTtoken, series, fileName3)
    .then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName3);
      document.body.appendChild(link);
      link.click();
      link.remove();
    })
    .catch(console.error) : toast.error('No File Selected');

  };
  // ------------------------------------------------------------------------
  const handleSelectFile4 = async (e) => {
    e.preventDefault()
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      setFile4(selectedFile);
      setFileName4(selectedFile.name);
      setfileSaveTrigger((prev)=>prev + 1)
      toast.success(`File Selected: ${selectedFile.name}`);
    }
  };

  const handleRemoveFile4 = () => {
    setFile4(null);
    setFileName4('No File Selected');
    setfileSaveTrigger(0);
    toast.error('File Removed');
  };

  const handleViewFile4 = async () => {
    // file4url ? window.open(file4url, '_blank') : toast.error('No File Selected');
    const JWTtoken = window.sessionStorage.getItem('token')

    fileName4 ? apiService.exportPreloadingView(JWTtoken, series, fileName4)
    .then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName4);
      document.body.appendChild(link);
      link.click();
      link.remove();
    })
    .catch(console.error) : toast.error('No File Selected');
  };
  // ------------------------------------------------------------------------

  const handleSelectFile5 = async (e) => {
    e.preventDefault()
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      setFile5(selectedFile);
      setFileName5(selectedFile.name);
      setfileSaveTrigger((prev)=>prev + 1) 
      toast.success(`File Selected: ${selectedFile.name}`);
    }
  };

  const handleRemoveFile5 = () => {
    setFile5(null);
    setFileName5('No File Selected');
    setfileSaveTrigger(0);
    toast.error('File Removed');
  };

  const handleViewFile5 = async () => {
    // file4url ? window.open(file5url, '_blank') : toast.error('No File Selected');
    const JWTtoken = window.sessionStorage.getItem('token')

    fileName5 ? apiService.exportPreloadingView(JWTtoken, series, fileName5)
    .then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName5);
      document.body.appendChild(link);
      link.click();
      link.remove();
    })
    .catch(console.error) : toast.error('No File Selected');
  };

  const handleEdit = () => {
    toast.success("EDIT Form");
    setIsReadOnly(false);
  };

  const handleAppvUserValidation = async () => {
  try {
      const JWTtoken = window.sessionStorage.getItem('token');
      const loginRole = window.sessionStorage.getItem('role');

      const response = await apiService.checkUserValidation(JWTtoken, series);

      if (loginRole === 'SALES') {
      if (response.data.userId === response.data.salesPersonID) {
          await handleOpenModal();
          await handleAutoSave();
          await setStep(1);
      } else {
          toast.error("Please proceed with your own opportunity");
      }
      } else {
      await handleOpenModal();
      await handleAutoSave();
      await setStep(1);
      }
  } catch (error) {
      console.log(':::::Error while verifying sales user before approval:', error);
      toast.error(`Error while verifying sales user before approval: ${error}`);
  }
  };

  const handleAdminAppvVal = async () => {
    try {
      const JWTtoken = window.sessionStorage.getItem('token')
      const approvalSenderEmail = window.sessionStorage.getItem('emailID');
      const approvalSenderEmpId = window.sessionStorage.getItem('userId');
      const approverSenderName = window.sessionStorage.getItem('userName');
      // await apiService.checkUserValidation(JWTtoken, series).then(response => {
      //   handleAutoSave()
      // })
      await apiService.requestApproval(JWTtoken, series, approvalSenderEmail, approverSenderName, approvalSenderEmpId)
      .then(response => {
        response.data.map(async (approver) => {
          let approvalRole = approver.role;
          console.log(':::::Approval Role::::>', approvalRole)
          if (approvalRole === 'TEAM LEADER') {
            setAppvTeamLeaderReq('YES')
          } else if (approvalRole === 'BRANCH HEAD') {
            setAppvBranchHeadReq('YES')
          } else if (approvalRole === 'REGION BUSINESS HEAD') {
            setAppvRegionBusinessHeadReq('YES')
          } else if (approvalRole === 'BUSINESS FINANCE') {
            setAppvBusinessFinanceReq('YES')
          } else if (approvalRole === 'EXPORT COMPLIANCE') {
            setAppvExportComplianceReq('YES')
          } else if (approvalRole === 'CREDIT INSURANCE') {
            setAppvCreditInsuranceReq('YES')
          } else if (approvalRole === 'CEO') {
            setAppvCEOReq('YES')
          } else if (approvalRole === 'COO') {
            setAppvCOOReq('YES')
          } else if (approvalRole === 'CFO') {
            setAppvCFOReq('YES')
          } else if (approvalRole === 'SVP-DIRECTOR') {
            setAppvSVPDirectorReq('YES')
          }
        });

        if (response.status == 200) {
          console.log(response)
          setTimeout(() => { window.location.reload() }, 2000);
          toast.success("All Approval Mails Sent", {
            autoClose: 2000,
          });
        }
      })

      await apiService.postAppNotifyRequestApproval(JWTtoken, series)

    } catch (error) {
      console.log(':::::Error while verifying sales user before approval:', error)
      toast.error(`Error while verifying sales user before approval:${error}`)
    }
  }

  const host = window.location.hostname;
  const handleAutoSave = async ({ event = null, fromButton = false, } = {}) => {
    if (event) event.preventDefault();
  
    let authUser = window.sessionStorage.getItem('role') === 'SALES'
      || window.sessionStorage.getItem('role') === 'OPERATIONS'
      || window.sessionStorage.getItem('role') === 'ADMIN'
      || window.sessionStorage.getItem('role') === 'BUSINESS FINANCE'
      || window.sessionStorage.getItem('role') === 'TEAM LEADER'
      || window.sessionStorage.getItem('role') === 'EXPORT COMPLIANCE'
    if (authUser) {
      // console.log(':::::selectedCrm.salesPersonID', salesPersonID)
      const preloadData = new FormData();
      preloadData.append("userName", userName);
      preloadData.append("userId", userId);
      preloadData.append("userRole", userRole);
      preloadData.append("formSeries", series);
      // preloadData.append("status", status);

      preloadData.append("file1", file1);
      preloadData.append("fileName1", fileName1);
      preloadData.append("file2", file2);
      preloadData.append("fileName2", fileName2);
      preloadData.append("file3", file3);
      preloadData.append("fileName3", fileName3);
      preloadData.append("file4", file4);
      preloadData.append("fileName4", fileName4);
      preloadData.append("file5", file5);
      preloadData.append("fileName5", fileName5);

      // preloadData.append("file1", selectedFile1);
      // preloadData.append("fileName1", selectedFile);
      // preloadData.append("file2", selectedFile1);
      // preloadData.append("fileName2", selectedFile);
      // preloadData.append("file3", selectedFile1);
      // preloadData.append("fileName3", selectedFile);
      // preloadData.append("file4", selectedFile1);
      // preloadData.append("fileName4", selectedFile);
      // preloadData.append("file5", selectedFile1);
      // preloadData.append("fileName5", selectedFile);

      preloadData.append("crmNumber", searchTerm);
      preloadData.append("customerName", customerName);
      preloadData.append("salesPersonName", salesPersonName);
      preloadData.append("salesPersonID", salesPersonID);
      preloadData.append("preloadingReason", preloadingReason);
      preloadData.append("lowMarginReason", lowMarginReason);
      preloadData.append("oem", oem);
      // preloadData.append("approvalRequestDate", approvalRequestDate);
      preloadData.append("approvalRequestDate", status === "Open" ? approvalRequestDate : sendForAppvReqDate );
      preloadData.append("opportunityName", opportunityName);
      preloadData.append("customerSatisfaction", customerSatisfaction);
      preloadData.append("expectedPOTimeDays", expectedPOTimeDays);
      preloadData.append("pan", panNumber);
      preloadData.append("customerCreditPeriodDays", customerCreditPeriodDays);
      preloadData.append("vendorDeliveryDays", vendorDeliveryDays);
      preloadData.append("vendorCreditPeriodDays", vendorCreditPeriodDays);
      preloadData.append("vendorBillingCycle", vendorBillingCycle);
      preloadData.append("expectedPODate", expectedPODate);
      preloadData.append("cashFlowExpertAdvice", cashFlowExpertAdvice);
      preloadData.append("marginExpertAdvice", marginExpertAdvice);
      preloadData.append("sellingValueYear1", sellingValueYear1);
      preloadData.append("sellingValueYear2", sellingValueYear2);
      preloadData.append("sellingValueYear3", sellingValueYear3);
      preloadData.append("sellingValueYear4", sellingValueYear4);
      preloadData.append("sellingValueYear5", sellingValueYear5);
      preloadData.append("sellingValueYear6", sellingValueYear6);
      preloadData.append("sellingValueYear7", sellingValueYear7);
      preloadData.append("sellingValueTotal", sellingValueTotal);
      preloadData.append("purchaseValueYear1", purchaseValueYear1);
      preloadData.append("purchaseValueYear2", purchaseValueYear2);
      preloadData.append("purchaseValueYear3", purchaseValueYear3);
      preloadData.append("purchaseValueYear4", purchaseValueYear4);
      preloadData.append("purchaseValueYear5", purchaseValueYear5);
      preloadData.append("purchaseValueYear6", purchaseValueYear6);
      preloadData.append("purchaseValueYear7", purchaseValueYear7);
      preloadData.append("purchaseValueTotal", purchaseValueTotal);
      preloadData.append("marginYear1", marginYear1);
      preloadData.append("marginYear2", marginYear2);
      preloadData.append("marginYear3", marginYear3);
      preloadData.append("marginYear4", marginYear4);
      preloadData.append("marginYear5", marginYear5);
      preloadData.append("marginYear6", marginYear6);
      preloadData.append("marginYear7", marginYear7);
      preloadData.append("marginYearTotal", marginYearTotal);
      preloadData.append("marginPercentage", marginPercentage);
      preloadData.append("ExCompQues1", ques1);
      preloadData.append("ExCompQues2", ques2);
      preloadData.append("ExCompQues3", ques3);
      preloadData.append("ExCompQues4", ques4);
      preloadData.append("ExCompQues5", ques5);
      preloadData.append("ExCompQues6", ques6);
      preloadData.append("ExCompQues7", ques7);
      preloadData.append("ExCompQues8", ques8);
      preloadData.append("ExCompQues9", ques9);
      preloadData.append("ExCompQues10", ques10);
      preloadData.append("ExCompQues11", ques11);
      preloadData.append("ExCompQues12", ques12);
      preloadData.append("ExCompQues13", ques13);
      preloadData.append("ExCompQues14", ques14);


      try {

        const JWTtoken = window.sessionStorage.getItem('token')
        // const response = await axios.post(`https://${host}:9001/savePreloadingData`, preloadData,
        const response = await axios.post(`https://${host}:9001/api/savePreloadingData`, preloadData,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
              'authorization': JWTtoken,
            },
          }
        )

        if (fromButton) {
          toast.success("Form Saved");
        }
        console.log(':::::Form submitted successfully:', response.data);
      } catch (error) {
        console.error('Error submitting form:', error);
        toast.error("Save failed");
      }
    }
  };

  const handleApproval = async () => {

    try {
      const JWTtoken = window.sessionStorage.getItem('token')
      const approvalSenderEmail = window.sessionStorage.getItem('emailID');
      const approvalSenderEmpId = window.sessionStorage.getItem('userId');
      const approverSenderName = window.sessionStorage.getItem('userName');
      setIsReadOnly(true)
      const confirmation = 'Required';
      await handleAutoSave()
      await apiService.checkApprovalTable(JWTtoken, series, confirmation)
                    .then((response) => {
      const approverRoles = response.data.map((a) => a.role); 

      const roleSetters = {
        "TEAM LEADER": setAppvTeamLeaderReq,
        "BRANCH HEAD": setAppvBranchHeadReq,
        "REGION BUSINESS HEAD": setAppvRegionBusinessHeadReq,
        "BUSINESS FINANCE": setAppvBusinessFinanceReq,
        "EXPORT COMPLIANCE": setAppvExportComplianceReq,
        "CREDIT INSURANCE": setAppvCreditInsuranceReq,
        "CEO": setAppvCEOReq,
        "COO": setAppvCOOReq,
        "CFO": setAppvCFOReq,
        "SVP-DIRECTOR": setAppvSVPDirectorReq,
      };

      Object.entries(roleSetters).forEach(([role, setter]) => {
        if (approverRoles.includes(role)) {
          setter("YES");
        } else {
          setter("NA");
        }
      });
        });

      await apiService.requestApproval(JWTtoken, series, approvalSenderEmail, approverSenderName, approvalSenderEmpId)
        .then(response => {
          response.data.map(async (approver) => {
            let approvalRole = approver.role;
            console.log(':::::Approval Role::::>', approvalRole)
            if (approvalRole === 'TEAM LEADER') {
              setAppvTeamLeaderReq('YES')
            } else if (approvalRole === 'BRANCH HEAD') {
              setAppvBranchHeadReq('YES')
            } else if (approvalRole === 'REGION BUSINESS HEAD') {
              setAppvRegionBusinessHeadReq('YES')
            } else if (approvalRole === 'BUSINESS FINANCE') {
              setAppvBusinessFinanceReq('YES')
            } else if (approvalRole === 'EXPORT COMPLIANCE') {
              setAppvExportComplianceReq('YES')
            } else if (approvalRole === 'CREDIT INSURANCE') {
              setAppvCreditInsuranceReq('YES')
            } else if (approvalRole === 'CEO') {
              setAppvCEOReq('YES')
            } else if (approvalRole === 'COO') {
              setAppvCOOReq('YES')
            } else if (approvalRole === 'CFO') {
              setAppvCFOReq('YES')
            } else if (approvalRole === 'SVP-DIRECTOR') {
              setAppvSVPDirectorReq('YES')
            }
          });

          if (response.status == 200) {
            console.log(response)
            setTimeout(() => { window.location.reload() }, 2000);
            toast.success("All Approval Mails Sent", {
              autoClose: 2000,
            });
          }
          setModalSentForAppv(false);
        })
        .catch(error => {
          setError(error);
        });

      const formFlag = 'PRELOAD';
      if(panNumber !== null && panNumber !== "NA" && panNumber !== ""){
        const approvalAmount = sellingValueTotal;
        await apiService.creditApprovalByPan(JWTtoken, panNumber, searchTerm, approvalAmount, series, formFlag)
                        .then(response => { 
                          console.log(response.data.message)
                        })
      }

      // await apiService.postAppNotifyRequestApproval(JWTtoken, series)

    } catch (error) {
      console.log(':::::Error while sending preloading for approval', error)
      toast.error(`Error while sending preloading for approval: ${error}`)
    }
  }

   const handleApprove = (e) => {
  
      if (approvalMessage === "") {
         e.preventDefault();
        let approvalStatus = "Approved";
        let approvalMessage = "Deal Approved";
        let approvalRole = window.sessionStorage.getItem('role');
        let approvalid = window.sessionStorage.getItem('userId');
  
        apiService
          .finalApproval(series, approvalStatus, approvalMessage, rejectionMessage, approvalRole, approvalid )
          .then((response) => {
            console.log(":::::Aprroval Approved:::::", response.data);
            setResponse("Thank you for your approval!");
            setShowThankYou(true);
          })
          .catch((error) => {
            setError(error);
          });
      } else {
        e.preventDefault();
        let approvalStatus = "Approved";
        let approvalRole = window.sessionStorage.getItem('role');
        let approvalid = window.sessionStorage.getItem('userId');
        
        apiService
          .finalApproval(series, approvalStatus, approvalMessage, rejectionMessage, approvalRole, approvalid )
          .then((response) => {
            console.log(":::::Aprroval Approved:::::", response.data);
            setResponse("Thank you for your approval!");
            setShowThankYou(true);
          })
          .catch((error) => {
            setError(error);
          });
      }
    };
  
    const handleReject = (e) => {
      if (rejectionMessage === "") {
        toast.error("Please provide a valid rejection reason ");
      } else {
        e.preventDefault();
        let approvalStatus = "Rejected";
        let approvalRole = window.sessionStorage.getItem('role');
        let approvalid = window.sessionStorage.getItem('userId');
        apiService
          .finalApproval(series, approvalStatus, approvalMessage, rejectionMessage, approvalRole, approvalid )
          .then((response) => {
            console.log(":::::Aprroval Rejected:::::", response.data);
            setResponse("Thank you for your response!");
            setShowThankYou(true);
          })
          .catch((error) => {
            setError(error);
          });
      }
    };
  
  const handleOpenModal = async () => {
    try {
      const JWTtoken = window.sessionStorage.getItem('token')

      await apiService.checkOpenOppType(JWTtoken, searchTerm)
        .then(response => {

            if (response.data.opportunityType === 'Open') {
            let hasError = false;

            const errorCheck = (condition, message) => {
                if (condition) {
                toast.error(message);
                hasError = true;
                }
            };

            errorCheck(!searchTerm || searchTerm.trim() === '', 'Please Select CRM Number');
            errorCheck(!preloadingReason || preloadingReason.trim() === '', 'Please fill Reason to Load the order as Preloading');
            errorCheck(!oem || oem.trim() === '', 'Please select Opportunity Category(OEM)');
            errorCheck(!customerSatisfaction || customerSatisfaction.trim() === '', 'Please select Do we have customer confirmation');
            errorCheck(!expectedPOTimeDays || isNaN(Number(expectedPOTimeDays)) || expectedPOTimeDays == 0, 'Please fill Expected Time(in Days) to get the final PO from Customer');
            errorCheck(!customerCreditPeriodDays || isNaN(Number(customerCreditPeriodDays)) || customerCreditPeriodDays == 0, 'Please fill Customer Credit Period for this Deal (in Days)');
            errorCheck(!vendorDeliveryDays || isNaN(Number(vendorDeliveryDays)) || vendorDeliveryDays == 0, 'Please fill Expected Days of Delivery of Product from Vendor');
            errorCheck(!vendorCreditPeriodDays || isNaN(Number(vendorCreditPeriodDays)) || vendorCreditPeriodDays == 0, 'Please fill Vendor Credit Period for this Deal (in Days)');
            errorCheck(!vendorBillingCycle || vendorBillingCycle.trim() === '', 'Please select Vendor Billing Cycle');
            errorCheck(!sellingValueTotal || isNaN(Number(sellingValueTotal)) || sellingValueTotal == 0, 'Please fill Selling Value (IN INR)');
            errorCheck(!purchaseValueTotal || isNaN(Number(purchaseValueTotal)) || purchaseValueTotal == 0, 'Please fill Purchase Value (IN INR)');
            errorCheck(!marginYearTotal || isNaN(Number(marginYearTotal)) || marginYearTotal == 0, 'Please fill Margin (IN INR)');

            if (customerSatisfaction === 'Yes') {
                errorCheck(!fileName1 || fileName1.trim() === '' || fileName1 === 'No File Selected', 'Please Upload Customer accepted proposal copy');
                errorCheck(!fileName2 || fileName2.trim() === '' || fileName2 === 'No File Selected', 'Please Upload Vendor TP with their payment terms and delivery timeline of that product');
                errorCheck(!fileName3 || fileName3.trim() === '' || fileName3 === 'No File Selected', 'Please Upload Customer confirmation with expected days of PO');
            } else if (customerSatisfaction === 'No') {
                errorCheck(!fileName1 || fileName1.trim() === '' || fileName1 === 'No File Selected', 'Please Upload Customer accepted proposal copy');
                errorCheck(!fileName2 || fileName2.trim() === '' || fileName2 === 'No File Selected', 'Please Upload Vendor TP with their payment terms and delivery timeline of that product');
            }

            // ✅ Final check: only proceed if no errors
            if (!hasError) {
                console.log('All checks passed. Setting modal.');
                setModalSentForAppv(true);
            }

            } else if (response.data.opportunityType === 'Won') {
            toast.error('This opportunity is already WON');
            } else if (response.data.opportunityType === 'Lost') {
            toast.error('This opportunity is already LOST');
            }


        })
      //  setModalSentForAppv(true);
    } catch (error) {
      console.log(':::::Error while sending preloading for approval', error)
      toast.error(`Error while sending preloading for approval: ${error}`)
    }
  };

  const handleCloseModal = () => setModalSentForAppv(false);


  const [isNoteVisible, setIsNoteVisible] = useState(false);

  const handleToggleNote = () => {
    setIsNoteVisible(!isNoteVisible);
  };

  const handleCloseReopenModal = () => setShowReopen(false);
  const handleShowReopenModal = () => setShowReopen(true);
  const handleReopenPrelaoding = async (status) => {
    try {
      const JWTtoken = window.sessionStorage.getItem('token')
      const response = await apiService.clearApprovals(JWTtoken, series)
        .then(response => {
          toast.success(`${series} is reopened for Re-Approvals`)
          handleCloseReopenModal()
        })
        .catch(error => {
          setError(error);
        });
      console.log(':::::Clear Approvals API Response:', response.data);
    } catch (error) {
      console.error('Error in API call:', error);
    }
  };

  const handleQuesNext = async (e) => {
    e.preventDefault();
    const JWTtoken = window.sessionStorage.getItem('token')
    const confirmation = 'Not Required';
    await handleAutoSave({ event: e, fromButton: false });
    await apiService.checkApprovalTable(JWTtoken, series, confirmation ).then((response) => {
      const approverRoles = response.data.map((a) => a.role); 

      const roleSetters = {
        "TEAM LEADER": setAppvTeamLeaderReq,
        "BRANCH HEAD": setAppvBranchHeadReq,
        "REGION BUSINESS HEAD": setAppvRegionBusinessHeadReq,
        "BUSINESS FINANCE": setAppvBusinessFinanceReq,
        "EXPORT COMPLIANCE": setAppvExportComplianceReq,
        "CREDIT INSURANCE": setAppvCreditInsuranceReq,
        "CEO": setAppvCEOReq,
        "COO": setAppvCOOReq,
        "CFO": setAppvCFOReq,
        "SVP-DIRECTOR": setAppvSVPDirectorReq,
      };

      Object.entries(roleSetters).forEach(([role, setter]) => {
        if (approverRoles.includes(role)) {
          setter("YES");
        } else {
          setter("NA");
        }
      });
    });

    setStep(2);
  };

  const renderEXCompQuestions = (index, label, value, onChange, readonly = false) => (
    <tr key={index}>
      <td>{index + 1}</td>
      <td><i className="fa-solid fa-star-of-life" style={{ color: '#e91717', fontSize: '10px', marginLeft: '1px' }} /> {label}</td>
      <td>
        <Form.Check inline label="Yes" name={label} type="radio" value="Yes" checked={value === 'Yes'} onChange={() => {onChange('Yes'); setExCompMessage(''); setExCompRemark(false); }}  disabled={readonly} />
        <Form.Check inline label="No" name={label} type="radio" value="No" checked={value === 'No'} onChange={() => {onChange('No'); setExCompMessage('');  setExCompRemark(false); }} disabled={readonly} />
      </td>
    </tr>
  );

  
  const handleExCompAppvRemark = async () => {
    const questions = [ques1, ques2, ques3, ques4, ques5, ques6, ques7,
       ques8, ques9, ques10, ques11, ques12, ques13, ques14 ];

       console.log("hellloo..",ques14);
       

    const isValid = questions.every(q => q === 'Yes' || q === 'No');

    if (!isValid) {
        alert('All questions are mandatory and must be either "Yes" or "No"!');
        return;
    }else{
      const num_ques1 = (ques1 === "Yes") ? 0 : (ques1 === "No") ? 1 : null;
      const num_ques2 = (ques2 === "Yes") ? 0 : (ques2 === "No") ? 1 : null;
      const num_ques3 = (ques3 === "Yes") ? 1 : (ques3 === "No") ? 0 : null;
      const num_ques4 = (ques4 === "Yes") ? 1 : (ques4 === "No") ? 0 : null;
      const num_ques5 = (ques5 === "Yes") ? 0 : (ques5 === "No") ? 1 : null;
      const num_ques6 = (ques6 === "Yes") ? 1 : (ques6 === "No") ? 0 : null;
      const num_ques7 = (ques7 === "Yes") ? 0 : (ques7 === "No") ? 1 : null;
      const num_ques8 = (ques8 === "Yes") ? 1 : (ques8 === "No") ? 0 : null;
      const num_ques9 = (ques9 === "Yes") ? 1 : (ques9 === "No") ? 0 : null;
      const num_ques10 = (ques10 === "Yes") ? 1 : (ques10 === "No") ? 0 : null;
      const num_ques11 = (ques11 === "Yes") ? 1 : (ques11 === "No") ? 0 : null;
      const num_ques12 = (ques12 === "Yes") ? 1 : (ques12 === "No") ? 0 : null;
      const num_ques13 = (ques13 === "Yes") ? 1 : (ques13 === "No") ? 0 : null;
      const num_ques14 = (ques14 === "Yes") ? 1 : (ques14 === "No") ? 0 : null;
      const sum_message = num_ques1 + num_ques2 + num_ques3 + num_ques4 + num_ques5 + num_ques6 + 
      num_ques7 + num_ques8 + num_ques9 + num_ques10 + num_ques11 + num_ques12 + num_ques13 + num_ques14
      
      sum_message == 0
        ? setExCompMessage('As per above declaration Export Compliance Approval is Not Required.')
        : sum_message >= 1
        ? setExCompMessage('As per above declaration Export Compliance Approval is Required.')
        : setExCompMessage('');
      setExCompRemark(true);
    }
    handleAutoSave()
  }

  // const handlePaste = (event) => {
  //   event.preventDefault();
  //   // alert("Pasting is not allowed in this field.");
  //   toast.error('Pasting is not allowed in the CRM Number field. Please enter the initial characters of the Opportunity ID and select the appropriate option from the dropdown.');
  // };

  const handlePaste = (event, fieldName) => { 
  event.preventDefault();

  if (fieldName === 'CRM Number') {
    toast.error(`Pasting is not allowed in ${fieldName}. Please type and select from the dropdown.`);
  }
  if (fieldName === 'PreloadingLoadReason') {
    toast.error(`Pasting is not allowed while entering Reason to Load the order as Preloading. Please type manually.`);
  }
  if (fieldName === 'LowMarginReasonFilled ') {
    toast.error(`Pasting is not allowed while entering Reason for Low Margin. Please type manually.`);
  }
  if (fieldName === 'Purchase_Value1') {
    toast.error(`Pasting is not allowed here. Please type manually.`);
  }
  if (fieldName === 'Purchase_Value2') {
    toast.error(`Pasting is not allowed here. Please type manually.`);
  }
  if (fieldName === 'Purchase_Value3') {
    toast.error(`Pasting is not allowed here. Please type manually.`);
  }
  if (fieldName === 'Purchase_Value4') {
    toast.error(`Pasting is not allowed here. Please type manually.`);
  }
  if (fieldName === 'Purchase_Value5') {
    toast.error(`Pasting is not allowed here. Please type manually.`);
  }
  if (fieldName === 'Purchase_Value6') {
    toast.error(`Pasting is not allowed here. Please type manually.`);
  }
  if (fieldName === 'Purchase_Value7') {
    toast.error(`Pasting is not allowed here. Please type manually.`);
  }
  if (fieldName === 'Selling_Value1') {
    toast.error(`Pasting is not allowed here. Please type manually.`);
  }
  if (fieldName === 'Selling_Value2') {
    toast.error(`Pasting is not allowed here. Please type manually.`);
  }
  if (fieldName === 'Selling_Value3') {
    toast.error(`Pasting is not allowed here. Please type manually.`);
  }
  if (fieldName === 'Selling_Value4') {
    toast.error(`Pasting is not allowed here. Please type manually.`);
  }
  if (fieldName === 'Selling_Value5') {
    toast.error(`Pasting is not allowed here. Please type manually.`);
  }
  if (fieldName === 'Selling_Value6') {
    toast.error(`Pasting is not allowed here. Please type manually.`);
  }
  if (fieldName === 'Selling_Value7') {
    toast.error(`Pasting is not allowed here. Please type manually.`);
  }
  
};


  const role = sessionStorage.getItem('role') === 'TEAM LEADER'

  if (loading) return <h1>Loading...</h1>;
  if (error) return <h1>Error: {error.message}</h1>;
  return (
    <>
      <Navbar />
      {/* <h1 className='headerRibbon'>Preloading Form Ops/Sales</h1> */}
      <Container className="pt-3">
        <Form className="">
          <Row className="mb-4 justify-content-between" data-row-name="logo & crmbutton">
            <Col md="auto">
              {/* <img src={logo} className="w-100 shadow-4" style={{ maxWidth: '150px', height: 'auto' }} alt="login_banner_image" /> */}
            </Col>
            <Col md="auto">
              <h1>Preloading Form</h1>
            </Col>
            <Col md="auto">
              {/* <Button variant="success" onClick={loadcrmdata}>Load CRM</Button> */}
            </Col>
          </Row>
          
          {/* Modal Component */}
         <Modal show={modalSentForAppv} onHide={handleCloseModal} size="xl" centered backdrop="static" keyboard={false}>
            <Modal.Header closeButton>
              <Modal.Title>
                {step === 1 ? 'Requirement of Export Compliance Approval' : 'Approval Mail Confirmation'}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {step === 1 ? (
                <Form>
                <Table bordered responsive>
                  <thead>
                    <tr>
                      <th>Sr. No.</th>
                      <th>Particulars</th>
                      <th>YES/NO</th>
                    </tr>
                  </thead>
                  <tbody>
                    {[
                      ["End User & Billing Customer Name is Same", ques1, setQues1],
                      ["Customer Billing Location is Domestic", ques2, setQues2],
                      ["Customer Billing Location is International, (if any)", ques3, setQues3],
                      ["Customer PO Issuance from International Location", ques4, setQues4],
                      ["End User Location is Domestic", ques5, setQues5],
                      ["End User Location is International, (if any)", ques6, setQues6],
                      ["PO Issued in INR", ques7, setQues7],
                      [`We Are Selling Following Product/Service :- (AI-Tool/CCTV Camera/ Drone / Surveillance Camera/Nvidia Graphic Card)`, ques8, setQues8],
                      [`We Are Selling Following OEM's Product :- (Hikvision, Dhaua, Huawei, Kaspersky Or Any Chinese Camera Manufacturer)`, ques9, setQues9],
                      ["Customer is Related To WMD (Weapons of Mass Destruction)/ Military/Defence/Nuclear/Aerospace", ques10, setQues10],
                      [`Customer/End Customer is Fall Under Category:- State Govt./Central Govt./PSU`, ques12, setQues12],
                      [`This deal is related to Tender`, ques13, setQues13],
                      [`Is customer having Global (Out of India) Presence`, ques14, setQues14],
                    ].map(([label, value, setter], index) => renderEXCompQuestions(index, label, value, setter, false, setExCompMessage, setExCompRemark) )}
                  </tbody>
                </Table>
                <span style={{color: 'grey', fontSize:'16px'}}>
                <i className="fa-solid fa-star-of-life" style={{ color: '#e91717', fontSize: '10px', marginLeft: '1px' }} />
                Declaration: I hereby declare that the information I have provided regarding export control matters is true, 
                complete, and accurate to the best of my knowledge based on available documentation and customer confirmation
                </span>
                <span style={ExCompMessage ? {display: 'block',textAlign: 'center',fontWeight: 'bold',color: 'black',backgroundColor: 'yellow',borderRadius: '5px',
                    padding: '8px',margin: '10px auto',width: 'fit-content'} : {}}>{ExCompMessage}</span>

                </Form>
              ) : (
                <>
                  <p>Are you sure you want to proceed, After this point mail will be triggered! To Following Approvers:</p>
            
                  <Row>
                    <Col xs={6}>
                      <span data-row-name="Approvers-common">
                        {appvTeamLeaderReq === 'YES' ? 'Team Leader' : ''}  <br />
                        {appvBranchHeadReq === 'YES' ? 'Branch Head' : ''}  <br />
                        {appvRegionBusinessHeadReq === 'YES' ? 'Region Business Head ' : ''}  <br />
                        {appvBusinessFinanceReq === 'YES' ? 'Business Finance' : ''}  <br />
                        {appvExportComplianceReq === 'YES' ? 'Export Compliance' : ''}
                      </span>
                    </Col>
                    <Col xs={6}>
                      <span data-row-name="Approvers-condition">
                        {appvCreditInsuranceReq === 'YES' ? 'Credit Insurance' : ''} <br />
                        {appvCFOReq === 'YES' ? 'CFO' : ''} <br />
                        {appvCEOReq === 'YES' ? 'CEO' : ''}  <br />
                        {appvCOOReq === 'YES' ? 'COO' : ''}   <br />
                        {appvSVPDirectorReq === 'YES' ? 'SVP-Director' : ''}
                      </span>
                    </Col>
                  </Row>
                </>
              )}
            </Modal.Body>
            <Modal.Footer>
              {step === 1 ? (
                <>
                {!showExCompRemark? (
                  <Button variant="info" 
                  onClick={handleExCompAppvRemark}>Check</Button>
                ) : (
                  <Button variant="secondary" onClick={handleQuesNext}>Next</Button>
                )}
              </>
              ) : (
                <>
                  <Button variant="primary" onClick={() => setStep(1)}>Back</Button>
                  <Button variant="secondary" onClick={handleCloseModal}>Close</Button>
                  <Button variant="success" onClick={handleApproval}>Confirm</Button>
                </>
              )}
            </Modal.Footer>
          </Modal>

          <Modal show={showReopen} onHide={handleCloseReopenModal}>
            <Modal.Header closeButton>
              <Modal.Title>Reopen Preloading</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              Are you sure you want to Re-Open this Preloading?
            </Modal.Body>
            <Modal.Footer>
              <Button variant="outline-secondary" onClick={handleCloseReopenModal}>
                Close
              </Button>
              <Button variant="outline-success" onClick={handleReopenPrelaoding}>
                Yes REOPEN !
              </Button>
            </Modal.Footer>
          </Modal>

          {(sessionStorage.getItem('role') === 'BUSINESS FINANCE' || sessionStorage.getItem('role') === 'ADMIN') && (
            <Row className="mt-4 mb-4 justify-content-between" data-row-name="save, edit and submit button">
              <Col>
               {(appvTeamLeaderStatus === 'Rejected' ||
                appvBranchHeadStatus === 'Rejected' ||
                appvRegionBusinessHeadStatus === 'Rejected' ||
                appvBusinessFinanceStatus === 'Rejected' ||
                appvExportComplianceStatus === 'Rejected' ||
                appvCreditInsuranceStatus === 'Rejected' ||
                appvCEOStatus === 'Rejected' ||
                appvCFOStatus === 'Rejected' ||
                appvCOOStatus === 'Rejected' ||
                appvSVPDirectorStatus === 'Rejected') && (
                  <Button variant="outline-danger" onClick={handleShowReopenModal}>
                    Reopen Preloading
                  </Button>
                )}
          
                {formReopenCount > 0 && (
                  <p style={{ padding: "2px" }}>
                    <b>Form Reopen Count: {formReopenCount}</b>
                  </p>
                )}

              </Col>
              <Col md="auto">
                <Button variant="outline-primary" onClick={handleEdit}>
                  Edit
                </Button>
              </Col>
              <Col md="auto">
                <Button variant="outline-primary" onClick={(e) => handleAutoSave({ event: e, fromButton: true })}>
                  Save
                </Button>
              </Col>
              <Col md="auto">
                <Button variant="outline-primary" onClick={handleAdminAppvVal}>
                  Send for Approval
                </Button>
              </Col>
            </Row>
          )}
          {(sessionStorage.getItem('role') === 'SALES' || sessionStorage.getItem('role') === 'OPERATIONS') && sendForAppv == false && (
            <Row className="mt-4 mb-4 justify-content-between" data-row-name="save, edit and submit button">
              <Col md="auto">
                <Button variant="primary" onClick={handleEdit}>
                  Edit
                </Button>
              </Col>
              <Col md="auto">
                <Button variant="primary" onClick={(e) => handleAutoSave({ event: e, fromButton: true })}>
                  Save
                </Button>
              </Col>
              <Col md="auto">
                <Button variant="primary" onClick={handleAppvUserValidation}>
                  Send for Approval
                </Button>
              </Col>
            </Row>
          )}

           {    (sessionStorage.getItem('role') === 'TEAM LEADER' && (salesPersonID == '' || salesPersonID == null || salesPersonID == sessionStorage.getItem('userId')) && sendForAppv === false) ? (
                    <Row className="mt-4 mb-4 justify-content-between" data-row-name="save, edit and submit button">
                    <Col md="auto">
                        <Button variant="primary" onClick={handleEdit}>Edit</Button>
                    </Col>
                    <Col md="auto">
                        <Button variant="primary" onClick={(e) => handleAutoSave({ event: e, fromButton: true })}>Save</Button>
                    </Col>
                    <Col md="auto">
                        <Button variant="primary" onClick={handleAppvUserValidation}>Send for Approval</Button>
                    </Col>
                    </Row>
                ) : (sessionStorage.getItem('role') === 'TEAM LEADER' && salesPersonID == sessionStorage.getItem('userId') && sendForAppv === true) ? ( null
                ) : (sessionStorage.getItem('role') === 'TEAM LEADER' && appvTeamLeaderId == sessionStorage.getItem('userId') && sendForAppv === true) ? (
                    !showThankYou ? (
                    <>
                        <Col className='d-flex justify-content-center pt-3'>
                        <h3>Please Provide Feedback</h3>
                        </Col>
                        <Row className="pt-4 justify-content-center">
                        <InputGroup>
                            <Form.Control
                            type="text"
                            placeholder="Approval message"
                            value={approvalMessage}
                            onChange={(e) => setApprovalMessage(e.target.value)}
                            />
                            <Button variant="success" onClick={handleApprove}>Approve</Button>
                        </InputGroup>
                        </Row>
                        <Row className="pt-4 pb-4 justify-content-center">
                        <InputGroup>
                            <Form.Control
                            type="text"
                            placeholder="Rejection message"
                            value={rejectionMessage}
                            onChange={(e) => setRejectionMessage(e.target.value)}
                            />
                            <Button variant="danger" onClick={handleReject}>Reject</Button>
                        </InputGroup>
                        </Row>
                    </>
                    ) : (
                    <div className='pt-5 pb-2'>
                        <Col className='d-flex justify-content-center pb-5'>
                        <h1 style={{ color: 'Green' }}>{response}</h1>
                        </Col>
                    </div>
                    )

                ) : (sessionStorage.getItem('role') === 'TEAM LEADER' && appvTeamLeaderId !== sessionStorage.getItem('userId') && sendForAppv === true) ? (
                     null
                ) : (sessionStorage.getItem('role') === 'TEAM LEADER') ? <div className='pt-5 pb-2'>
                          <Col className='d-flex justify-content-center pb-5'>
                          <h1 style={{ color: 'Green' }}>{response}</h1>
                          </Col>
                    </div>: null    
            }

            {    (sessionStorage.getItem('role') === 'CEO' && (salesPersonID == '' || salesPersonID == null || salesPersonID == sessionStorage.getItem('userId')) && sendForAppv === false) ? (
                    <Row className="mt-4 mb-4 justify-content-between" data-row-name="save, edit and submit button">
                    <Col md="auto">
                        <Button variant="primary" onClick={handleEdit}>Edit</Button>
                    </Col>
                    <Col md="auto">
                        <Button variant="primary" onClick={(e) => handleAutoSave({ event: e, fromButton: true })}>Save</Button>
                    </Col>
                    <Col md="auto">
                        <Button variant="primary" onClick={handleAppvUserValidation}>Send for Approval</Button>
                    </Col>
                    </Row>
                ) : (sessionStorage.getItem('role') === 'CEO' && salesPersonID == sessionStorage.getItem('userId') && sendForAppv === true) ? ( null
                ) : (sessionStorage.getItem('role') === 'CEO' && appvCEOId == sessionStorage.getItem('userId') && sendForAppv === true) ? (
                    !showThankYou ? (
                    <>
                        <Col className='d-flex justify-content-center pt-3'>
                        <h3>Please Provide Feedback</h3>
                        </Col>
                        <Row className="pt-4 justify-content-center">
                        <InputGroup>
                            <Form.Control
                            type="text"
                            placeholder="Approval message"
                            value={approvalMessage}
                            onChange={(e) => setApprovalMessage(e.target.value)}
                            />
                            <Button variant="success" onClick={handleApprove}>Approve</Button>
                        </InputGroup>
                        </Row>
                        <Row className="pt-4 pb-4 justify-content-center">
                        <InputGroup>
                            <Form.Control
                            type="text"
                            placeholder="Rejection message"
                            value={rejectionMessage}
                            onChange={(e) => setRejectionMessage(e.target.value)}
                            />
                            <Button variant="danger" onClick={handleReject}>Reject</Button>
                        </InputGroup>
                        </Row>
                    </>
                    ) : (
                    <div className='pt-5 pb-2'>
                        <Col className='d-flex justify-content-center pb-5'>
                        <h1 style={{ color: 'Green' }}>{response}</h1>
                        </Col>
                    </div>
                    )

                ) : (sessionStorage.getItem('role') === 'CEO' && appvCEOId !== sessionStorage.getItem('userId') && sendForAppv === true) ? ( null
                ) : (sessionStorage.getItem('role') === 'CEO') ? <div className='pt-5 pb-2'>
                          <Col className='d-flex justify-content-center pb-5'>
                          <h1 style={{ color: 'Green' }}>{response}</h1>
                          </Col>
                    </div>: null    
            }

            {    (sessionStorage.getItem('role') === 'CFO' && (salesPersonID == '' || salesPersonID == null || salesPersonID == sessionStorage.getItem('userId')) && sendForAppv === false) ? (
                    <Row className="mt-4 mb-4 justify-content-between" data-row-name="save, edit and submit button">
                    <Col md="auto">
                        <Button variant="primary" onClick={handleEdit}>Edit</Button>
                    </Col>
                    <Col md="auto">
                        <Button variant="primary" onClick={(e) => handleAutoSave({ event: e, fromButton: true })}>Save</Button>
                    </Col>
                    <Col md="auto">
                        <Button variant="primary" onClick={handleAppvUserValidation}>Send for Approval</Button>
                    </Col>
                    </Row>
                ) : (sessionStorage.getItem('role') === 'CFO' && salesPersonID == sessionStorage.getItem('userId') && sendForAppv === true) ? ( null
                ) : (sessionStorage.getItem('role') === 'CFO' && appvCFOId == sessionStorage.getItem('userId') && sendForAppv === true) ? (
                    !showThankYou ? (
                    <>
                        <Col className='d-flex justify-content-center pt-3'>
                        <h3>Please Provide Feedback</h3>
                        </Col>
                        <Row className="pt-4 justify-content-center">
                        <InputGroup>
                            <Form.Control
                            type="text"
                            placeholder="Approval message"
                            value={approvalMessage}
                            onChange={(e) => setApprovalMessage(e.target.value)}
                            />
                            <Button variant="success" onClick={handleApprove}>Approve</Button>
                        </InputGroup>
                        </Row>
                        <Row className="pt-4 pb-4 justify-content-center">
                        <InputGroup>
                            <Form.Control
                            type="text"
                            placeholder="Rejection message"
                            value={rejectionMessage}
                            onChange={(e) => setRejectionMessage(e.target.value)}
                            />
                            <Button variant="danger" onClick={handleReject}>Reject</Button>
                        </InputGroup>
                        </Row>
                    </>
                    ) : (
                    <div className='pt-5 pb-2'>
                        <Col className='d-flex justify-content-center pb-5'>
                        <h1 style={{ color: 'Green' }}>{response}</h1>
                        </Col>
                    </div>
                    )

                ) : (sessionStorage.getItem('role') === 'CFO' && appvCFOId !== sessionStorage.getItem('userId') && sendForAppv === true) ? ( null
                ) : (sessionStorage.getItem('role') === 'CFO') ? <div className='pt-5 pb-2'>
                          <Col className='d-flex justify-content-center pb-5'>
                          <h1 style={{ color: 'Green' }}>{response}</h1>
                          </Col>
                    </div>: null    
            }

          {(sessionStorage.getItem('role') === 'BRANCH HEAD' || sessionStorage.getItem('role') === 'REGION BUSINESS HEAD' ||
            sessionStorage.getItem('role') === 'EXPORT COMPLIANCE' || sessionStorage.getItem('role') === 'BUSINESS FINANCE' || sessionStorage.getItem('role') === 'CREDIT INSURANCE' ||
            sessionStorage.getItem('role') === 'COO' || sessionStorage.getItem('role') === 'SVP-DIRECTOR' || sessionStorage.getItem('role') === 'ADMIN') && (
              <>
                {!showThankYou ? (
                  <>
                    <Col className='d-flex justify-content-center pt-3'>
                      <h3>Please Provide Feedback</h3>
                    </Col>
                    <Row className="pt-4 justify-content-center">
                      <InputGroup>
                        <Form.Control
                          type="text"
                          placeholder="Approval message"
                          value={approvalMessage}
                          onChange={(e) => setApprovalMessage(e.target.value)}
                        />
                        <Button variant="success" onClick={handleApprove}>Approve</Button>
                      </InputGroup>
                    </Row>
                    <Row className="pt-4 pb-4 justify-content-center">
                      <InputGroup>
                        <Form.Control
                          type="text"
                          placeholder="Rejection message"
                          value={rejectionMessage}
                          onChange={(e) => setRejectionMessage(e.target.value)}
                        />
                        <Button variant="danger" onClick={handleReject}>Reject</Button>
                      </InputGroup>
                    </Row>
                  </>
                ) : (
                  <div className='pt-5 pb-2'>
                    <Col className='d-flex justify-content-center pb-5'>
                      <h1 style={{ color: 'Green' }} >{response}</h1>
                    </Col>
                  </div>
                )}
              </>
          )}
          
          {appvTeamLeaderReq === 'YES' && <Row className="mb-1" data-row-name="Approvers-head">
            <Col md="" style={{ fontWeight: 'bold' }}>
              Approval Required:
            </Col>
          </Row>
          }
          <Row className="mb-1" data-row-name="Approvers-common">
            {appvTeamLeaderReq === 'YES' && (
              <Col md="" style={{
                fontWeight: 'bold', border: '1px solid black', textAlign: 'center',
                color: appvTeamLeaderStatus === 'Approved' ? 'green' : appvTeamLeaderStatus === 'Rejected' ? 'red' : 'inherit',
                backgroundColor: appvTeamLeaderStatus === 'Approved' ? 'lightgreen' : appvTeamLeaderStatus === 'Rejected' ? 'lightcoral' : 'inherit',
              }}>
                TEAM LEADER
              </Col>
            )}

            {appvBranchHeadReq === 'YES' &&
              <Col md="" style={{
                fontWeight: 'bold', border: '1px solid black', textAlign: 'center',
                color: appvBranchHeadStatus === 'Approved' ? 'green' : appvBranchHeadStatus === 'Rejected' ? 'red' : 'inherit',
                backgroundColor: appvBranchHeadStatus === 'Approved' ? 'lightgreen' : appvBranchHeadStatus === 'Rejected' ? 'lightcoral' : 'inherit',
              }}>
                BRANCH HEAD
              </Col>
            }
            {appvRegionBusinessHeadReq === 'YES' &&
              <Col md="" style={{
                fontWeight: 'bold', border: '1px solid black', textAlign: 'center',
                color: appvRegionBusinessHeadStatus === 'Approved' ? 'green' : appvRegionBusinessHeadStatus === 'Rejected' ? 'red' : 'inherit',
                backgroundColor: appvRegionBusinessHeadStatus === 'Approved' ? 'lightgreen' : appvRegionBusinessHeadStatus === 'Rejected' ? 'lightcoral' : 'inherit',
              }}>
                REGION BUSINESS HEAD
              </Col>
            }
            {appvBusinessFinanceReq === 'YES' &&
              <Col md="" style={{
                fontWeight: 'bold', border: '1px solid black', textAlign: 'center',
                color: appvBusinessFinanceStatus === 'Approved' ? 'green' : appvBusinessFinanceStatus === 'Rejected' ? 'red' : 'inherit',
                backgroundColor: appvBusinessFinanceStatus === 'Approved' ? 'lightgreen' : appvBusinessFinanceStatus === 'Rejected' ? 'lightcoral' : 'inherit',
              }}>
                BUSINESS FINANCE
              </Col>
            }
            {appvCreditInsuranceReq === 'YES' &&
              <Col md="" style={{
                fontWeight: 'bold', border: '1px solid black', textAlign: 'center',
                color: appvCreditInsuranceStatus === 'Approved' ? 'green' : appvCreditInsuranceStatus === 'Rejected' ? 'red' : 'inherit',
                backgroundColor: appvCreditInsuranceStatus === 'Approved' ? 'lightgreen' : appvCreditInsuranceStatus === 'Rejected' ? 'lightcoral' : 'inherit',
              }}>
                CREDIT INSURANCE
              </Col>
            }

          </Row>
          <Row className="mb-1" data-row-name="Approvers-condition">
            {appvExportComplianceReq === 'YES' ? (
              <Col md="" style={{
                fontWeight: 'bold', border: '1px solid black', textAlign: 'center',
                color: appvExportComplianceStatus === 'Approved' ? 'green' : appvExportComplianceStatus === 'Rejected' ? 'red' : 'inherit',
                backgroundColor: appvExportComplianceStatus === 'Approved' ? 'lightgreen' : appvExportComplianceStatus === 'Rejected' ? 'lightcoral' : 'inherit',
              }}>
                EXPORT COMPLIANCE
              </Col>
            ) : (null)}
            {appvCFOReq === 'YES' ? (
              <Col md="" style={{
                fontWeight: 'bold', border: '1px solid black', textAlign: 'center',
                color: appvCFOStatus === 'Approved' ? 'green' : appvCFOStatus === 'Rejected' ? 'red' : 'inherit',
                backgroundColor: appvCFOStatus === 'Approved' ? 'lightgreen' : appvCFOStatus === 'Rejected' ? 'lightcoral' : 'inherit',
              }}>
                CFO
              </Col>
            ) : (null)}
            {appvCEOReq === 'YES' ? (
              <Col md="" style={{
                fontWeight: 'bold', border: '1px solid black', textAlign: 'center',
                color: appvCEOStatus === 'Approved' ? 'green' : appvCEOStatus === 'Rejected' ? 'red' : 'inherit',
                backgroundColor: appvCEOStatus === 'Approved' ? 'lightgreen' : appvCEOStatus === 'Rejected' ? 'lightcoral' : 'inherit',
              }}>
                CEO
              </Col>
            ) : (null)}
            {appvCOOReq === 'YES' ? (
              <Col md="" style={{
                fontWeight: 'bold', border: '1px solid black', textAlign: 'center',
                color: appvCOOStatus === 'Approved' ? 'green' : appvCOOStatus === 'Rejected' ? 'red' : 'inherit',
                backgroundColor: appvCOOStatus === 'Approved' ? 'lightgreen' : appvCOOStatus === 'Rejected' ? 'lightcoral' : 'inherit',
              }}>
                COO
              </Col>
            ) : (null)}
            {appvSVPDirectorReq === 'YES' ? (
              <Col md="" style={{
                fontWeight: 'bold', border: '1px solid black', textAlign: 'center',
                color: appvSVPDirectorStatus === 'Approved' ? 'green' : appvSVPDirectorStatus === 'Rejected' ? 'red' : 'inherit',
                backgroundColor: appvSVPDirectorStatus === 'Approved' ? 'lightgreen' : appvSVPDirectorStatus === 'Rejected' ? 'lightcoral' : 'inherit',
              }}>
                SVP-DIRECTOR
              </Col>
            ) : (null)}
          </Row>

          <section style={{ position: 'relative', border: '2px solid #ccc', padding: '15px', paddingRight: '4px' }} >
            {(status === 'Approved'|| status === 'PO Received') && (
              <div style={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%) rotate(-10deg) scale(0.1)',
                zIndex: 100,
                // pointerEvents: 'none' // optional: lets clicks pass through if needed
              }}>
                <img src={approvedStamp} alt="Centered" />
              </div>
            )}
            <Row className="mb-1" data-row-name="Document ID">
              <Col md="5" className="customformlabel"><Form.Label>Document ID</Form.Label></Col>
              <Col md="7">
                <Form.Control type="text" readOnly value={series} />
              </Col>
            </Row>
            <Row className="mb-1" data-row-name="CRM Number">
              <Col md="5" className="customformlabel"><Form.Label>CRM Number
              <i className="fa-solid fa-star-of-life" style={{ color: 'red', fontSize: '10px', paddingLeft: '2px' }} />
              </Form.Label></Col>
              <Col md="7" className="searchable-select-container">
                <input type="text" placeholder="Select CRM Number" value={searchTerm} onFocus={() => setShowDropdown(true)} 
                onBlur={
                  (e) => {setShowDropdown(false)
                  handleAutoSave({ event: e, fromButton: false })
                }
              }
                  onChange={(e) => { if (!isReadOnly) { setSearchTerm(e.target.value); setShowDropdown(true); } }} readOnly={isReadOnly} onPaste={(e) => handlePaste(e, 'CRM Number')} className="searchable-select-input"
                />
                {showDropdown && !isReadOnly && (
                  <div className="searchable-select-dropdown">
                    {filteredCrmData.length > 0 ? (
                      filteredCrmData.map(item => (
                        <div key={item.crmNumber} value={item.crmNumber} 
                        onMouseDown={() => handleSelectChange(item.crmNumber)}
                        // onBlur={(e) => handleAutoSave({ event: e, fromButton: false })} 
                        // onMouseDown={(e) => handleCRMNumberSelction(e, item.crmNumber)}
                        className="searchable-select-item">
                          {item.crmNumber}
                        </div>
                      ))
                    ) : (
                      <div className="searchable-select-item disabled">No results found</div>
                    )}
                  </div>
                )}
                <div
                  style={{ position: 'absolute', display: 'inline-block', paddingLeft: '10px', paddingTop: '10px' }}
                  onMouseEnter={() => setIsNoteVisible(true)}
                  onMouseLeave={() => setIsNoteVisible(false)}
                >


                  <i className="fa fa-info-circle" style={{ fontSize: '20px', cursor: 'pointer' }}></i>

                  {isNoteVisible && (
                    <div
                      style={{
                        position: 'absolute',
                        top: '100%',
                        left: '50%',
                        transform: 'translateX(-50%)',
                        backgroundColor: 'white',
                        border: '1px solid #ccc',
                        padding: '10px',
                        zIndex: 1,
                        minWidth: '300px',
                        boxShadow: '0 2px 5px rgba(0, 0, 0, 0.2)',
                        whiteSpace: 'normal',
                      }}
                    >
                      CRM Number will be updated after every one hour.
                    </div>
                  )}
                </div>
              </Col>
            </Row>
            <Row className="mb-1" data-row-name="Customer Name">
              <Col md="5" className="customformlabel"><Form.Label>Customer Name</Form.Label></Col>
              <Col md="7"><Form.Control type="text" value={customerName} readOnly /></Col>
            </Row>
            <Row className="mb-1" data-row-name="Sales Person Name">
              <Col md="5" className="customformlabel"><Form.Label>Sales Person Name</Form.Label></Col>
              <Col md="7"><Form.Control type="text" value={salesPersonName} readOnly /></Col>
            </Row>
            {/* <Row className="mb-1" data-row-name="Reason to Load the order as Preloading">
              <Col md="5" className="customformlabel"><Form.Label>
                Reason to Load the order as Preloading
                <i className="fa-solid fa-star-of-life" style={{ color: 'red', fontSize: '10px', paddingLeft: '2px' }} />
              </Form.Label></Col>
              <Col md="7">
                <Form.Control type="text" readOnly={isReadOnly}
                  value={preloadingReason}
                  onBlur={(e) => handleAutoSave({ event: e, fromButton: false })} 
                  onChange={(e) => setpreloadingReason(e.target.value)} aria-label="preloadingReason"
                  // onChange={(e) => { setpreloadingReason(e.target.value); debouncedSaveRef.current(); }}
                />
              </Col>
            </Row> */}
            <Row className="mb-1" data-row-name="Reason to Load the order as Preloading">
              <Col md="5" className="customformlabel"><Form.Label>Reason to Load the order as Preloading
                  <i className="fa-solid fa-star-of-life" style={{ color: 'red', fontSize: '10px', paddingLeft: '2px' }} />
                </Form.Label>
              </Col>

              <Col md="7">
                <Form.Control type="text" readOnly={isReadOnly} value={preloadingReason} maxLength={300} onBlur={(e) => handleAutoSave({ event: e, fromButton: false })}
                  onPaste={(e) => handlePaste(e, 'PreloadingLoadReason')}
                  onChange={(e) => {if (e.target.value.length <= 300) { setpreloadingReason(e.target.value); }}} aria-label="preloadingReason" />
                <div className="text-end text-muted small">{preloadingReason.length}/300</div>
              </Col>
            </Row>
            <Row className="mb-1" data-row-name="OEM">
              <Col md="5" className="customformlabel"><Form.Label>Opportunity Category(OEM)
                <i className="fa-solid fa-star-of-life" style={{ color: 'red', fontSize: '10px', paddingLeft: '2px' }} />
              </Form.Label></Col>
              <Col md="7">
                <Form.Select value={oem} disabled={isReadOnly} onBlur={(e) => handleAutoSave({ event: e, fromButton: false })} onChange={(e) => setOem(e.target.value)} aria-label="OEM">
                  <option value="" disabled>Select Opportunity Category(OEM)</option>
                  <option value="Microsoft">Microsoft</option>
                  <option value="Other than Microsoft">Other than Microsoft</option>
                </Form.Select>
              </Col>
            </Row>
            {/* {( sendForAppv == false && (
              <Row className="mb-1" data-row-name="Approval Request Date">
                  <Col md="5" className="customformlabel"><Form.Label>Approval Request Date</Form.Label></Col>
                  <Col md="7">
                  <Form.Control value={approvalRequestDate} type="text" readOnly />
                  </Col>
              </Row>
            ))}
            {( sendForAppv == true && (
              <Row className="mb-1" data-row-name="Approval Request Date">
                  <Col md="5" className="customformlabel"><Form.Label>Approval Request Date</Form.Label></Col>
                  <Col md="7">
                  <Form.Control value={sendForAppvReqDate} type="text" readOnly />
                  </Col>
              </Row>
            ))} */}
            <Row className="mb-1" data-row-name="Approval Request Date">
              <Col md="5" className="customformlabel">
                <Form.Label>Approval Request Date</Form.Label>
              </Col>
              <Col md="7">
              {/* value={status === "Open" ? approvalRequestDate : sendForAppvReqDate} */}

                <Form.Control
                  value={status === "Open" ? moment(approvalRequestDate).format("dddd, DD MMMM, YYYY") : moment(sendForAppvReqDate).format("dddd, DD MMMM, YYYY")}
                  type="text"
                  readOnly
                />
              </Col>
            </Row>

            {/* <Row className="mb-1" data-row-name="Approval Request Date">
              <Col md="5" className="customformlabel"><Form.Label>Approval Request Date</Form.Label></Col>
              <Col md="7"><Form.Control value={sendForAppv ? sendForAppvReqDate : approvalRequestDate} type="text" readOnly /></Col>
            </Row> */}

            <Row className="mb-1" data-row-name="Opportunity Name">
              <Col md="5" className="customformlabel"><Form.Label>Opportunity Name</Form.Label></Col>
              <Col md="7"><Form.Control type="text" value={opportunityName} readOnly maxLength={300} aria-label="opportunityName"/>
              </Col>
            </Row>

            {/* <Row className="mb-1" data-row-name="Opportunity Name">
              <Col md="5" className="customformlabel"><Form.Label>Opportunity Name</Form.Label></Col>
              <Col md="7"><Form.Control type="text" value={opportunityName} readOnly /></Col>
            </Row> */}
            <Row className="mb-1" data-row-name="Do we have customer confirmation">
              <Col md="5" className="customformlabel"><Form.Label>Do we have customer confirmation
                <i className="fa-solid fa-star-of-life" style={{ color: 'red', fontSize: '10px', paddingLeft: '2px' }} />
              </Form.Label></Col>
              <Col md="7">
                <Form.Select value={customerSatisfaction} disabled={isReadOnly} onBlur={(e) => handleAutoSave({ event: e, fromButton: false })}
                  onChange={(e) => setcustomerSatisfaction(e.target.value)} aria-label="Do we have customer confirmation">
                  <option value="" disabled>Select Option</option>
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                </Form.Select>
              </Col>
            </Row>
            <Row className="mb-1" data-row-name="Expected Time(in Days) to get the final PO from Customer">
              <Col md="5" className="customformlabel"><Form.Label>Expected Time(in Days) to get the final PO from Customer
                <i className="fa-solid fa-star-of-life" style={{ color: 'red', fontSize: '10px', paddingLeft: '2px' }} />
              </Form.Label></Col>
              <Col md="7">
                <Form.Control type="text" value={expectedPOTimeDays} onBlur={(e) => handleAutoSave({ event: e, fromButton: false })} readOnly={isReadOnly} onChange={(e) => {
                  setexpectedPOTimeDays(e.target.value)
                  setexpectedPODate(e.target.value ? moment().add((e.target.value), 'days').format('YYYY-MM-DD') : null)
                }} />
              </Col>
            </Row>
            <Row className="mb-1" data-row-name="Customer Credit Period for this Deal (in Days)">
              <Col md="5" className="customformlabel"><Form.Label>Customer Credit Period for this Deal (in Days)
                <i className="fa-solid fa-star-of-life" style={{ color: 'red', fontSize: '10px', paddingLeft: '2px' }} />
              </Form.Label></Col>
              <Col md="7">
                <Form.Control type="text" readOnly={isReadOnly} onBlur={(e) => handleAutoSave({ event: e, fromButton: false })} value={customerCreditPeriodDays} onChange={(e) => {
                  setcustomerCreditPeriodDays(e.target.value)
                  // setsubDaycashFlowExpertAdvice(moment(expectedPODate, 'dddd, D MMMM, YYYY').subtract((e.target.value), 'days').format('dddd, D MMMM, YYYY'))
                }} />
              </Col>
            </Row>
            <Row className="mb-1" data-row-name="Expected Days of Delivery of Product from Vendor">
              <Col md="5" className="customformlabel"><Form.Label>Expected Days of Delivery of Product from Vendor
                <i className="fa-solid fa-star-of-life" style={{ color: 'red', fontSize: '10px', paddingLeft: '2px' }} />
              </Form.Label></Col>
              <Col md="7">
                <Form.Control type="text" readOnly={isReadOnly} onBlur={(e) => handleAutoSave({ event: e, fromButton: false })} value={vendorDeliveryDays} onChange={(e) => setvendorDeliveryDays(e.target.value)} />
              </Col>
            </Row>
            <Row className="mb-1" data-row-name="Vendor Credit Period for this Deal (in Days)">
              <Col md="5" className="customformlabel"><Form.Label>Vendor Credit Period for this Deal (in Days)
                <i className="fa-solid fa-star-of-life" style={{ color: 'red', fontSize: '10px', paddingLeft: '2px' }} />
              </Form.Label></Col>
              <Col md="7">
                <Form.Control type="text" readOnly={isReadOnly} onBlur={(e) => handleAutoSave({ event: e, fromButton: false })} value={vendorCreditPeriodDays}
                  onChange={(e) => setvendorCreditPeriodDays(e.target.value)} />
              </Col>
            </Row>
            <Row className="mb-1" data-row-name="Vendor Billing Cycle">
              <Col md="5" className="customformlabel"><Form.Label>Vendor Billing Cycle
                <i className="fa-solid fa-star-of-life" style={{ color: 'red', fontSize: '10px', paddingLeft: '2px' }} />
              </Form.Label></Col>
              <Col md="7">
                <Form.Select value={vendorBillingCycle} disabled={isReadOnly} onBlur={(e) => handleAutoSave({ event: e, fromButton: false })} onChange={(e) => setvendorBillingCycle(e.target.value)} aria-label="Vendor Billing Cycle">
                  <option value='' disabled> Select Vendor Billing Cycle</option>
                  <option value="Same as Customer">Same as Customer</option>
                  <option value="UpFront">UpFront</option>
                  <option value="Deffered">Deffered</option>
                </Form.Select>
              </Col>
            </Row>
            <Row className="mb-1" data-row-name="Expected PO Date (Calculated)">
              <Col md="5" className="customformlabel"><Form.Label>Expected PO Date (Calculated)</Form.Label></Col>
              <Col md="7">
                <Form.Control type="text" readOnly style={{ fontWeight: 'bold' }} value={
                  expectedPODate ? moment(expectedPODate).format("dddd, DD MMMM, YYYY") : ""
                } />
              </Col>
            </Row>
          </section>
          <section style={{ padding: '15px' }} >
            <Row className="mb-0" data-row-name="Yearly Breakup table">
              <Table striped bordered hover>
                <thead>
                  <tr>
                    <th>Yearly Breakup</th>
                    <th>Year 1</th>
                    <th>Year 2</th>
                    <th>Year 3</th>
                    <th>Year 4</th>
                    <th>Year 5</th>
                    <th>Year 6</th>
                    <th>Year 7</th>
                    <th>Total</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th>Selling Value (IN INR)<i className="fa-solid fa-star-of-life" style={{ color: 'red', fontSize: '10px', paddingLeft: '2px' }} /></th>
                    <td>
                      <FormControl
                        type="text"
                        value={new Intl.NumberFormat('en-IN').format(sellingValueYear1)}
                        readOnly={isReadOnly}
                        onBlur={(e) => handleAutoSave({ event: e, fromButton: false })}
                        onPaste={(e) => handlePaste(e, 'Selling_Value1')}
                        onChange={(e) => {
                          // const cleanedValue = e.target.value.replace(/,/g, '');
                          const value = e.target.value;

                          // Allow only numbers and commas
                          if (!/^[0-9,]*$/.test(value)) return;

                          const cleanedValue = value.replace(/,/g, '');
                          const numericValue = isNaN(cleanedValue) ? '' : Number(cleanedValue);
                          setsellingValueYear1(numericValue);
                        }}
                      />
                    </td>
                    <td>
                      <FormControl
                        type="text"
                        value={new Intl.NumberFormat('en-IN').format(sellingValueYear2)}
                        readOnly={isReadOnly}
                        onBlur={(e) => handleAutoSave({ event: e, fromButton: false })}
                        onPaste={(e) => handlePaste(e, 'Selling_Value2')}
                        onChange={(e) => {
                          const cleanedValue = e.target.value.replace(/,/g, '');
                          const numericValue = isNaN(cleanedValue) ? '' : Number(cleanedValue);
                          setsellingValueYear2(numericValue);
                        }}
                      />
                    </td>
                    <td>
                      <FormControl
                        type="text"
                        value={new Intl.NumberFormat('en-IN').format(sellingValueYear3)}
                        readOnly={isReadOnly}
                        onBlur={(e) => handleAutoSave({ event: e, fromButton: false })}
                        onPaste={(e) => handlePaste(e, 'Selling_Value3')}
                        onChange={(e) => {
                          const cleanedValue = e.target.value.replace(/,/g, '');
                          const numericValue = isNaN(cleanedValue) ? '' : Number(cleanedValue);
                          setsellingValueYear3(numericValue);
                        }}
                      />
                    </td>
                    <td>
                      <FormControl
                        type="text"
                        value={new Intl.NumberFormat('en-IN').format(sellingValueYear4)}
                        readOnly={isReadOnly}
                        onBlur={(e) => handleAutoSave({ event: e, fromButton: false })}
                        onPaste={(e) => handlePaste(e, 'Selling_Value4')}
                        onChange={(e) => {
                          const cleanedValue = e.target.value.replace(/,/g, '');
                          const numericValue = isNaN(cleanedValue) ? '' : Number(cleanedValue);
                          setsellingValueYear4(numericValue);
                        }}
                      />
                    </td>
                    <td>
                      <FormControl
                        type="text"
                        value={new Intl.NumberFormat('en-IN').format(sellingValueYear5)}
                        readOnly={isReadOnly}
                        onBlur={(e) => handleAutoSave({ event: e, fromButton: false })}
                        onPaste={(e) => handlePaste(e, 'Selling_Value5')}
                        onChange={(e) => {
                          const cleanedValue = e.target.value.replace(/,/g, '');
                          const numericValue = isNaN(cleanedValue) ? '' : Number(cleanedValue);
                          setsellingValueYear5(numericValue);
                        }}
                      />
                    </td>
                    <td>
                      <FormControl
                        type="text"
                        value={new Intl.NumberFormat('en-IN').format(sellingValueYear6)}
                        readOnly={isReadOnly}
                        onBlur={(e) => handleAutoSave({ event: e, fromButton: false })}
                        onPaste={(e) => handlePaste(e, 'Selling_Value6')}
                        onChange={(e) => {
                          const cleanedValue = e.target.value.replace(/,/g, '');
                          const numericValue = isNaN(cleanedValue) ? '' : Number(cleanedValue);
                          setsellingValueYear6(numericValue);
                        }}
                      />
                    </td>
                    <td>
                      <FormControl
                        type="text"
                        value={new Intl.NumberFormat('en-IN').format(sellingValueYear7)}
                        readOnly={isReadOnly}
                        onBlur={(e) => handleAutoSave({ event: e, fromButton: false })}
                        onPaste={(e) => handlePaste(e, 'Selling_Value7')}
                        onChange={(e) => {
                          const cleanedValue = e.target.value.replace(/,/g, '');
                          const numericValue = isNaN(cleanedValue) ? '' : Number(cleanedValue);
                          setsellingValueYear7(numericValue);
                        }}
                      />
                    </td>
                    <td>
                      <FormControl
                        type="text"
                        value={new Intl.NumberFormat('en-IN').format(sellingValueTotal)}
                        readOnly={isReadOnly}
                        onBlur={(e) => handleAutoSave({ event: e, fromButton: false })}
                        onChange={(e) => {
                          const cleanedValue = e.target.value.replace(/,/g, '');
                          const numericValue = isNaN(cleanedValue) ? '' : Number(cleanedValue);
                          setsellingValueTotal(numericValue);
                        }}
                      />
                    </td>
                  </tr>
                  <tr>
                    <th>Purchase Value (IN INR)<i className="fa-solid fa-star-of-life" style={{ color: 'red', fontSize: '10px', paddingLeft: '2px' }} /></th>
                    <td>
                      <FormControl
                        type="text"
                        value={new Intl.NumberFormat('en-IN').format(purchaseValueYear1)}
                        readOnly={isReadOnly}
                        onBlur={(e) => handleAutoSave({ event: e, fromButton: false })}
                        onPaste={(e) => handlePaste(e, 'Purchase_Value1')}
                        onChange={(e) => {
                          const cleanedValue = e.target.value.replace(/,/g, '');
                          const numericValue = isNaN(cleanedValue) ? '' : Number(cleanedValue);
                          setpurchaseValueYear1(numericValue);
                        }}
                      />
                    </td>
                    <td>
                      <FormControl
                        type="text"
                        value={new Intl.NumberFormat('en-IN').format(purchaseValueYear2)}
                        readOnly={isReadOnly}
                        onBlur={(e) => handleAutoSave({ event: e, fromButton: false })}
                        onPaste={(e) => handlePaste(e, 'Purchase_Value2')}
                        onChange={(e) => {
                          const cleanedValue = e.target.value.replace(/,/g, '');
                          const numericValue = isNaN(cleanedValue) ? '' : Number(cleanedValue);
                          setpurchaseValueYear2(numericValue);
                        }}
                      />
                    </td>
                    <td>
                      <FormControl
                        type="text"
                        value={new Intl.NumberFormat('en-IN').format(purchaseValueYear3)}
                        readOnly={isReadOnly}
                        onBlur={(e) => handleAutoSave({ event: e, fromButton: false })}
                        onPaste={(e) => handlePaste(e, 'Purchase_Value3')}
                        onChange={(e) => {
                          const cleanedValue = e.target.value.replace(/,/g, '');
                          const numericValue = isNaN(cleanedValue) ? '' : Number(cleanedValue);
                          setpurchaseValueYear3(numericValue);
                        }}
                      />
                    </td>
                    <td>
                      <FormControl
                        type="text"
                        value={new Intl.NumberFormat('en-IN').format(purchaseValueYear4)}
                        readOnly={isReadOnly}
                        onBlur={(e) => handleAutoSave({ event: e, fromButton: false })}
                        onPaste={(e) => handlePaste(e, 'Purchase_Value4')}
                        onChange={(e) => {
                          const cleanedValue = e.target.value.replace(/,/g, '');
                          const numericValue = isNaN(cleanedValue) ? '' : Number(cleanedValue);
                          setpurchaseValueYear4(numericValue);
                        }}
                      />
                    </td>
                    <td>
                      <FormControl
                        type="text"
                        value={new Intl.NumberFormat('en-IN').format(purchaseValueYear5)}
                        readOnly={isReadOnly}
                        onBlur={(e) => handleAutoSave({ event: e, fromButton: false })}
                        onPaste={(e) => handlePaste(e, 'Purchase_Value5')}
                        onChange={(e) => {
                          const cleanedValue = e.target.value.replace(/,/g, '');
                          const numericValue = isNaN(cleanedValue) ? '' : Number(cleanedValue);
                          setpurchaseValueYear5(numericValue);
                        }}
                      />
                    </td>
                    <td>
                      <FormControl
                        type="text"
                        value={new Intl.NumberFormat('en-IN').format(purchaseValueYear6)}
                        readOnly={isReadOnly}
                        onBlur={(e) => handleAutoSave({ event: e, fromButton: false })}
                        onPaste={(e) => handlePaste(e, 'Purchase_Value6')}
                        onChange={(e) => {
                          const cleanedValue = e.target.value.replace(/,/g, '');
                          const numericValue = isNaN(cleanedValue) ? '' : Number(cleanedValue);
                          setpurchaseValueYear6(numericValue);
                        }}
                      />
                    </td>
                    <td>
                      <FormControl
                        type="text"
                        value={new Intl.NumberFormat('en-IN').format(purchaseValueYear7)}
                        readOnly={isReadOnly}
                        onBlur={(e) => handleAutoSave({ event: e, fromButton: false })}
                        onPaste={(e) => handlePaste(e, 'Purchase_Value7')}
                        onChange={(e) => {
                          const cleanedValue = e.target.value.replace(/,/g, '');
                          const numericValue = isNaN(cleanedValue) ? '' : Number(cleanedValue);
                          setpurchaseValueYear7(numericValue);
                        }}
                      />
                    </td>
                    <td>
                      <FormControl
                        type="text"
                        value={new Intl.NumberFormat('en-IN').format(purchaseValueTotal)}
                        readOnly={isReadOnly}
                        onBlur={(e) => handleAutoSave({ event: e, fromButton: false })}
                        onChange={(e) => {
                          const cleanedValue = e.target.value.replace(/,/g, '');
                          const numericValue = isNaN(cleanedValue) ? '' : Number(cleanedValue);
                          setpurchaseValueTotal(numericValue);
                        }}
                      />
                    </td>
                  </tr>
                  <tr>
                    <th>Margin (IN INR)</th>
                    <td>
                      <FormControl
                        type="text"
                        value={new Intl.NumberFormat('en-IN').format(marginYear1)}
                        readOnly={isReadOnly}
                        onBlur={(e) => handleAutoSave({ event: e, fromButton: false })}
                        onChange={(e) => {
                          const cleanedValue = e.target.value.replace(/,/g, '');
                          const numericValue = isNaN(cleanedValue) ? '' : Number(cleanedValue);
                          setmarginYear1(numericValue);
                        }}
                      />
                    </td>
                    <td>
                      <FormControl
                        type="text"
                        value={new Intl.NumberFormat('en-IN').format(marginYear2)}
                        readOnly={isReadOnly}
                        onBlur={(e) => handleAutoSave({ event: e, fromButton: false })}
                        onChange={(e) => {
                          const cleanedValue = e.target.value.replace(/,/g, '');
                          const numericValue = isNaN(cleanedValue) ? '' : Number(cleanedValue);
                          setmarginYear2(numericValue);
                        }}
                      />
                    </td>
                    <td>
                      <FormControl
                        type="text"
                        value={new Intl.NumberFormat('en-IN').format(marginYear3)}
                        readOnly={isReadOnly}
                        onBlur={(e) => handleAutoSave({ event: e, fromButton: false })}
                        onChange={(e) => {
                          const cleanedValue = e.target.value.replace(/,/g, '');
                          const numericValue = isNaN(cleanedValue) ? '' : Number(cleanedValue);
                          setmarginYear3(numericValue);
                        }}
                      />
                    </td>
                    <td>
                      <FormControl
                        type="text"
                        value={new Intl.NumberFormat('en-IN').format(marginYear4)}
                        readOnly={isReadOnly}
                        onBlur={(e) => handleAutoSave({ event: e, fromButton: false })}
                        onChange={(e) => {
                          const cleanedValue = e.target.value.replace(/,/g, '');
                          const numericValue = isNaN(cleanedValue) ? '' : Number(cleanedValue);
                          setmarginYear4(numericValue);
                        }}
                      />
                    </td>
                    <td>
                      <FormControl
                        type="text"
                        value={new Intl.NumberFormat('en-IN').format(marginYear5)}
                        readOnly={isReadOnly}
                        onBlur={(e) => handleAutoSave({ event: e, fromButton: false })}
                        onChange={(e) => {
                          const cleanedValue = e.target.value.replace(/,/g, '');
                          const numericValue = isNaN(cleanedValue) ? '' : Number(cleanedValue);
                          setmarginYear5(numericValue);
                        }}
                      />
                    </td>
                    <td>
                      <FormControl
                        type="text"
                        value={new Intl.NumberFormat('en-IN').format(marginYear6)}
                        readOnly={isReadOnly}
                        onBlur={(e) => handleAutoSave({ event: e, fromButton: false })}
                        onChange={(e) => {
                          const cleanedValue = e.target.value.replace(/,/g, '');
                          const numericValue = isNaN(cleanedValue) ? '' : Number(cleanedValue);
                          setmarginYear6(numericValue);
                        }}
                      />
                    </td>
                    <td>
                      <FormControl
                        type="text"
                        value={new Intl.NumberFormat('en-IN').format(marginYear7)}
                        readOnly={isReadOnly}
                        onBlur={(e) => handleAutoSave({ event: e, fromButton: false })}
                        onChange={(e) => {
                          const cleanedValue = e.target.value.replace(/,/g, '');
                          const numericValue = isNaN(cleanedValue) ? '' : Number(cleanedValue);
                          setmarginYear7(numericValue);
                        }}
                      />
                    </td>
                    <td>
                      <FormControl
                        type="text"
                        value={new Intl.NumberFormat('en-IN').format(marginYearTotal)}
                        readOnly={isReadOnly}
                        onBlur={(e) => handleAutoSave({ event: e, fromButton: false })}
                        onChange={(e) => {
                          const cleanedValue = e.target.value.replace(/,/g, '');
                          const numericValue = isNaN(cleanedValue) ? '' : Number(cleanedValue);
                          setmarginYearTotal(numericValue);
                        }}
                      />
                    </td>
                  </tr>
                  <tr>
                    <th>Margin %</th>
                    <td>
                      <FormControl
                        type="text"
                        value={`${marginPercentage}%`}
                        readOnly={isReadOnly}
                        onChange={(e) => setmarginPercentage(e.target.value)}
                      />
                    </td>
                  </tr>
                </tbody>
              </Table>
            </Row>
          </section>
          <section style={{ border: '2px solid #ccc', padding: '15px', paddingRight: '4px', marginBottom: '20px' }} >
            <Row className="mb-1" data-row-name="Expert advice from Company's Cashflow Prospective">
              <Col md="5" className="customformlabel"><Form.Label>Expert advice from Company's Cashflow Prospective</Form.Label></Col>
              <Col md="7">
                <Form.Control as="textarea" type="text" row={2} readOnly value={cashFlowExpertAdvice}
                  onChange={(e) => setcashFlowExpertAdvice(e.target.value)}
                  className={
                    cashFlowExpertAdvice === "It's favourable to Hitachi"
                      ? 'cashFlowExpertAdvicefavourable'
                      : cashFlowExpertAdvice === "It's become FC Impacted deal, hence wait for customer PO"
                        ? 'cashFlowExpertAdviceimpacted'
                        : cashFlowExpertAdvice === "" // If empty string
                          ? 'cashFlowExpertAdvicedefault' // Apply default class
                          : null // No class for other cases
                  }
                />
              </Col>
            </Row>
            <Row className="mb-1" data-row-name="Expert advice from Company's Margin Prospective">
              <Col md="5" className="customformlabel"><Form.Label>Expert advice from Company's Margin Prospective</Form.Label></Col>
              <Col md="7">
                <Form.Control as="textarea" type="text" readOnly value={marginExpertAdvice} rows={2} onChange={(e) => setmarginExpertAdvice(e.target.value)}
                  className={
                    marginExpertAdvice === "Ok from margin prospective"
                      ? 'cashFlowExpertAdvicefavourable'
                      : marginExpertAdvice === "Since margin very low hence work on margin first, then move to pre-loading of the order"
                        ? 'cashFlowExpertAdviceimpacted'
                        : marginExpertAdvice === "" // If empty string
                          ? 'cashFlowExpertAdvicedefault' // Apply default class
                          : null // No class for other cases
                  } />
              </Col>
            </Row>
            <Row className="mb-1" data-row-name="Reason for Low Margin">
              <Col md="5" className="customformlabel">
                <Form.Label> Reason for Low Margin</Form.Label>
              </Col>
              <Col md="7">
                <Form.Control type="text" 
                readOnly={isReadOnly} 
                value={lowMarginReason}
                onBlur={(e) => handleAutoSave({ event: e, fromButton: false })} 
                onPaste={(e) => handlePaste(e, 'LowMarginReasonFilled')}
                onChange={(e) => {if (e.target.value.length <= 300) { setLowMarginReason(e.target.value); }}} aria-label="LowMarginReason" />
                <div className="text-end text-muted small">{lowMarginReason?.length}/300</div>
              </Col>
            </Row>
          </section>
          <section style={{ border: '2px solid #ccc', padding: '15px', paddingRight: '4px', marginBottom: '20px' }}>
            <Row className="mt-2 mb-1" data-row-name="Upload Document-1">
              <Col md="5" className="customformlabel"><Form.Label>Customer accepted proposal copy
                <i className="fa-solid fa-star-of-life" style={{ color: 'red', fontSize: '10px', paddingLeft: '2px' }} />
              </Form.Label></Col>
              <Col md="7">
                <InputGroup>
                  <Form.Control type="text" value={fileName1} aria-label="Upload Document-1" readOnly />
                  <Form.Control type="file" onChange={(e) => handleSelectFile1(e)} style={{ display: 'none' }} id="file-input-1" />
                  <Button variant="outline-primary" id="file-del-1" onClick={() => { document.getElementById('file-input-1').click(); }} disabled={isReadOnly}><MDBIcon fas icon="file-upload" size='lg' /></Button>
                  <Button variant="outline-danger" onClick={handleRemoveFile1} disabled={!fileName1 || isReadOnly}><MDBIcon fas icon="trash" /></Button>
                  <Button variant="outline-success" onClick={handleViewFile1}><MDBIcon fas icon="file-download" /></Button>
                </InputGroup>
              </Col>
            </Row>
            <Row className="mb-1" data-row-name="Upload Document-2">
              <Col md="5" className="customformlabel"><Form.Label> Vendor TP with their payment terms and delivery timeline of that product
                <i className="fa-solid fa-star-of-life" style={{ color: 'red', fontSize: '10px', paddingLeft: '2px' }} />
              </Form.Label></Col>
              <Col md="7">
                <InputGroup>
                  <Form.Control type="text" value={fileName2} aria-label="Upload Document-2" readOnly />
                  <Form.Control type="file" onChange={handleSelectFile2} style={{ display: 'none' }} id="file-input-2" />
                  <Button variant="outline-primary" id="file-del-2" onClick={() => document.getElementById('file-input-2').click()} disabled={isReadOnly}><MDBIcon fas icon="file-upload" size='lg' /></Button>
                  <Button variant="outline-danger" onClick={handleRemoveFile2} disabled={!fileName2 || isReadOnly}><MDBIcon fas icon="trash" /></Button>
                  <Button variant="outline-success" onClick={handleViewFile2}><MDBIcon fas icon="file-download" /></Button>
                </InputGroup>
              </Col>
            </Row>
            {customerSatisfaction !== 'No' && (
              <Row className="mb-1" data-row-name="Upload Document-3">
                <Col md="5" className="customformlabel"><Form.Label>Customer confirmation with expected days of PO
                  <i className="fa-solid fa-star-of-life" style={{ color: 'red', fontSize: '10px', paddingLeft: '2px' }} />
                </Form.Label></Col>
                <Col md="7">
                  <InputGroup>
                    <Form.Control type="text" value={fileName3} aria-label="Upload Document-3" readOnly />
                    <Form.Control type="file" onChange={handleSelectFile3} style={{ display: 'none' }} id="file-input-3" />
                    <Button variant="outline-primary" id="file-del-3" onClick={() => document.getElementById('file-input-3').click()} disabled={isReadOnly}><MDBIcon fas icon="file-upload" size='lg' /></Button>
                    <Button variant="outline-danger" onClick={handleRemoveFile3} disabled={!fileName3 || isReadOnly}><MDBIcon fas icon="trash" /></Button>
                    <Button variant="outline-success" onClick={handleViewFile3}><MDBIcon fas icon="file-download" /></Button>
                  </InputGroup>
                </Col>
              </Row>
            )}
            <Row className="mb-1" data-row-name="Upload Document-4">
              <Col md="5" className="customformlabel"><Form.Label>Additional Document</Form.Label></Col>
              <Col md="7">
                <InputGroup>
                  <Form.Control type="text" value={fileName4} aria-label="Upload Document-4" readOnly />
                  <Form.Control type="file" onChange={handleSelectFile4} style={{ display: 'none' }} id="file-input-4" />
                  <Button variant="outline-primary" id="file-del-4" onClick={() => document.getElementById('file-input-4').click()} disabled={isReadOnly}><MDBIcon fas icon="file-upload" size='lg' /></Button>
                  <Button variant="outline-danger" onClick={handleRemoveFile4} disabled={!fileName4 || isReadOnly}><MDBIcon fas icon="trash" /></Button>
                  <Button variant="outline-success" onClick={handleViewFile4}><MDBIcon fas icon="file-download" /></Button>
                </InputGroup>
              </Col>
            </Row>
            { sessionStorage.getItem('role') === 'EXPORT COMPLIANCE' && (
               <Row className="mb-1" data-row-name="Upload EXCOMP Document">
               <Col md="4" className="customformlabel">
               <Form.Label>Upload Ex-Comp Doc</Form.Label>
               </Col>
               <Col md="1">
               <Button variant="dark" onClick={(e) => handleAutoSave({ event: e, fromButton: true })}>
                  Save
                </Button>
               </Col>
               <Col md="7">
                 <InputGroup>
                   <Form.Control type="text" value={fileName5} aria-label="Upload EXCOMP Document" />
                   <Form.Control type="file" onChange={handleSelectFile5} style={{ display: 'none' }} id="file-input-5" />
                   <Button variant="outline-primary" id="file-del-5" onClick={() => document.getElementById('file-input-5').click()} ><MDBIcon fas icon="file-upload" size='lg' /></Button>
                   <Button variant="outline-danger" onClick={handleRemoveFile5} disabled={!fileName5}><MDBIcon fas icon="trash" /></Button>
                   <Button variant="outline-success" onClick={handleViewFile5}><MDBIcon fas icon="file-download" /></Button>
                 </InputGroup>
               </Col>
             </Row>
            )}
          </section>
          {( sendForAppv == true && (
          <section style={{ border: '2px solid #ccc', padding: '15px', paddingRight: '4px', marginBottom: '20px' }}>
          <Row className="mb-1" data-row-name="ExCompQues1">
              <Col md="5" className="customformlabel"><Form.Label>End User & Billing Customer Name is Same
                <i className="fa-solid fa-star-of-life" style={{ color: 'red', fontSize: '10px', paddingLeft: '2px' }} />
                </Form.Label></Col>
              <Col md="7"><Form.Control type="text" value={ques1} readOnly /></Col>
          </Row>
          <Row className="mb-1" data-row-name="ExCompQues2">
              <Col md="5" className="customformlabel"><Form.Label>Customer Billing Location is Domestic
                <i className="fa-solid fa-star-of-life" style={{ color: 'red', fontSize: '10px', paddingLeft: '2px' }} />
                </Form.Label></Col>
              <Col md="7"><Form.Control type="text" value={ques2} readOnly /></Col>
          </Row>
          <Row className="mb-1" data-row-name="ExCompQues3">
              <Col md="5" className="customformlabel"><Form.Label>Customer Billing Location is International,(if any)
                <i className="fa-solid fa-star-of-life" style={{ color: 'red', fontSize: '10px', paddingLeft: '2px' }} />
                </Form.Label></Col>
              <Col md="7"><Form.Control type="text" value={ques3} readOnly /></Col>
          </Row>
          <Row className="mb-1" data-row-name="ExCompQue4s">
              <Col md="5" className="customformlabel"><Form.Label>Customer PO Issuance from International Location
                <i className="fa-solid fa-star-of-life" style={{ color: 'red', fontSize: '10px', paddingLeft: '2px' }} />
                </Form.Label></Col>
              <Col md="7"><Form.Control type="text" value={ques4} readOnly /></Col>
          </Row>
          <Row className="mb-1" data-row-name="ExCompQues5">
              <Col md="5" className="customformlabel"><Form.Label>End User Location is Domestic
                <i className="fa-solid fa-star-of-life" style={{ color: 'red', fontSize: '10px', paddingLeft: '2px' }} />
                </Form.Label></Col>
              <Col md="7"><Form.Control type="text" value={ques5} readOnly /></Col>
          </Row>
          <Row className="mb-1" data-row-name="ExCompQues6">
              <Col md="5" className="customformlabel"><Form.Label>End User Location is International, (if any)
                <i className="fa-solid fa-star-of-life" style={{ color: 'red', fontSize: '10px', paddingLeft: '2px' }} />
                </Form.Label></Col>
              <Col md="7"><Form.Control type="text" value={ques6} readOnly /></Col>
          </Row>
          <Row className="mb-1" data-row-name="ExCompQues7">
              <Col md="5" className="customformlabel"><Form.Label>PO Issued in INR
                <i className="fa-solid fa-star-of-life" style={{ color: 'red', fontSize: '10px', paddingLeft: '2px' }} />
                </Form.Label></Col>
              <Col md="7"><Form.Control type="text" value={ques7} readOnly /></Col>
          </Row>
          <Row className="mb-1" data-row-name="ExCompQues8">
              <Col md="5" className="customformlabel"><Form.Label>We Are Selling Following Product/Service :- 
                (AI-Tool/CCTV Camera/ Drone / Surveillance Camera/Nvidia Graphic Card)
              <i className="fa-solid fa-star-of-life" style={{ color: 'red', fontSize: '10px', paddingLeft: '2px' }} />
              </Form.Label></Col>
              <Col md="7"><Form.Control type="text" value={ques8} readOnly /></Col>
          </Row>
          <Row className="mb-1" data-row-name="ExCompQues9">
              <Col md="5" className="customformlabel"><Form.Label>We Are Selling Following OEM's Product :-
                (Hikvision, Dhaua, Huawei, Kaspersky Or Any Chinese Camera Manufacturer)
              <i className="fa-solid fa-star-of-life" style={{ color: 'red', fontSize: '10px', paddingLeft: '2px' }} />
              </Form.Label></Col>
              <Col md="7"><Form.Control type="text" value={ques9} readOnly /></Col>
          </Row>
          <Row className="mb-1" data-row-name="ExCompQues10">
              <Col md="5" className="customformlabel"><Form.Label>Customer is Related To WMD (Weapons of Mass Destruction)/ Military/Defence/Nuclear/Aerospace
                <i className="fa-solid fa-star-of-life" style={{ color: 'red', fontSize: '10px', paddingLeft: '2px' }} />
                </Form.Label></Col>
              <Col md="7"><Form.Control type="text" value={ques10} readOnly /></Col>
          </Row>
          <Row className="mb-1" data-row-name="ExCompQues12">
              <Col md="5" className="customformlabel"><Form.Label>Customer/End Customer is Fall Under Category:- State Govt./Central Govt./PSU
                <i className="fa-solid fa-star-of-life" style={{ color: 'red', fontSize: '10px', paddingLeft: '2px' }} />
                </Form.Label></Col>
              <Col md="7"><Form.Control type="text" value={ques12} readOnly /></Col>
          </Row>
          <Row className="mb-1" data-row-name="ExCompQues13">
              <Col md="5" className="customformlabel"><Form.Label>This deal is related to Tender
                <i className="fa-solid fa-star-of-life" style={{ color: 'red', fontSize: '10px', paddingLeft: '2px' }} />
                </Form.Label></Col>
              <Col md="7"><Form.Control type="text" value={ques13} readOnly /></Col>
          </Row>
          <Row className="mb-1" data-row-name="ExCompQues14">
              <Col md="5" className="customformlabel"><Form.Label>Is customer having Global (Out of India) Presence
                <i className="fa-solid fa-star-of-life" style={{ color: 'red', fontSize: '10px', paddingLeft: '2px' }} />
                </Form.Label></Col>
              <Col md="7"><Form.Control type="text" value={ques14} readOnly /></Col>
          </Row>
          </section>
          ))}
        </Form>
      </Container >
    </>
  );
}

export default PreloadingForm;
